/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createPreparedForm = /* GraphQL */ `mutation CreatePreparedForm(
  $input: CreatePreparedFormInput!
  $condition: ModelPreparedFormConditionInput
) {
  createPreparedForm(input: $input, condition: $condition) {
    id
    caseID
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    companyID
    foreignNationalID
    foreignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    relativeAdmins
    state
    preparerID
    preparer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    templateID
    template {
      id
      name
      processes
      archived
      updatedAt
      requiresAttorneyApproval
      requiresSponsorApproval
      requiresNationalApproval
      employersCanView
      nationalsCanView
      __typename
    }
    completedFormID
    completedForm {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    completedFormHistory {
      nextToken
      __typename
    }
    assignedToID
    assignedToEmployerID
    assignedToNationalID
    assignedToTeamMemberID
    assignedToEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    assignedToNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    assignedToTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    rejectedDate
    rejectedByID
    rejectedByEmployerID
    rejectedByNationalID
    rejectedByTeamMemberID
    rejectedByEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    rejectedByNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    rejectedByTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    requiresAttorneyApproval
    attorneyApproverID
    attorneyApprover {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    attorneyApprovalDate
    requiresSponsorApproval
    sponsorApproverID
    sponsorApproverEmployerID
    sponsorApproverNationalID
    sponsorApproverEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    sponsorApproverNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    sponsorApprovalDate
    requiresNationalApproval
    nationalApproverID
    nationalApprover {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    nationalApprovalDate
    finalCaseManagerApproverID
    finalCaseManagerApprover {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    finalCaseManagerApprovalDate
    employersCanView
    nationalsCanView
    createdAt
    updatedAt
    comments {
      nextToken
      __typename
    }
    activities {
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePreparedFormMutationVariables,
  APITypes.CreatePreparedFormMutation
>;
export const updatePreparedForm = /* GraphQL */ `mutation UpdatePreparedForm(
  $input: UpdatePreparedFormInput!
  $condition: ModelPreparedFormConditionInput
) {
  updatePreparedForm(input: $input, condition: $condition) {
    id
    caseID
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    companyID
    foreignNationalID
    foreignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    relativeAdmins
    state
    preparerID
    preparer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    templateID
    template {
      id
      name
      processes
      archived
      updatedAt
      requiresAttorneyApproval
      requiresSponsorApproval
      requiresNationalApproval
      employersCanView
      nationalsCanView
      __typename
    }
    completedFormID
    completedForm {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    completedFormHistory {
      nextToken
      __typename
    }
    assignedToID
    assignedToEmployerID
    assignedToNationalID
    assignedToTeamMemberID
    assignedToEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    assignedToNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    assignedToTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    rejectedDate
    rejectedByID
    rejectedByEmployerID
    rejectedByNationalID
    rejectedByTeamMemberID
    rejectedByEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    rejectedByNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    rejectedByTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    requiresAttorneyApproval
    attorneyApproverID
    attorneyApprover {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    attorneyApprovalDate
    requiresSponsorApproval
    sponsorApproverID
    sponsorApproverEmployerID
    sponsorApproverNationalID
    sponsorApproverEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    sponsorApproverNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    sponsorApprovalDate
    requiresNationalApproval
    nationalApproverID
    nationalApprover {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    nationalApprovalDate
    finalCaseManagerApproverID
    finalCaseManagerApprover {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    finalCaseManagerApprovalDate
    employersCanView
    nationalsCanView
    createdAt
    updatedAt
    comments {
      nextToken
      __typename
    }
    activities {
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePreparedFormMutationVariables,
  APITypes.UpdatePreparedFormMutation
>;
export const deletePreparedForm = /* GraphQL */ `mutation DeletePreparedForm(
  $input: DeletePreparedFormInput!
  $condition: ModelPreparedFormConditionInput
) {
  deletePreparedForm(input: $input, condition: $condition) {
    id
    caseID
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    companyID
    foreignNationalID
    foreignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    relativeAdmins
    state
    preparerID
    preparer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    templateID
    template {
      id
      name
      processes
      archived
      updatedAt
      requiresAttorneyApproval
      requiresSponsorApproval
      requiresNationalApproval
      employersCanView
      nationalsCanView
      __typename
    }
    completedFormID
    completedForm {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    completedFormHistory {
      nextToken
      __typename
    }
    assignedToID
    assignedToEmployerID
    assignedToNationalID
    assignedToTeamMemberID
    assignedToEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    assignedToNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    assignedToTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    rejectedDate
    rejectedByID
    rejectedByEmployerID
    rejectedByNationalID
    rejectedByTeamMemberID
    rejectedByEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    rejectedByNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    rejectedByTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    requiresAttorneyApproval
    attorneyApproverID
    attorneyApprover {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    attorneyApprovalDate
    requiresSponsorApproval
    sponsorApproverID
    sponsorApproverEmployerID
    sponsorApproverNationalID
    sponsorApproverEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    sponsorApproverNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    sponsorApprovalDate
    requiresNationalApproval
    nationalApproverID
    nationalApprover {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    nationalApprovalDate
    finalCaseManagerApproverID
    finalCaseManagerApprover {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    finalCaseManagerApprovalDate
    employersCanView
    nationalsCanView
    createdAt
    updatedAt
    comments {
      nextToken
      __typename
    }
    activities {
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePreparedFormMutationVariables,
  APITypes.DeletePreparedFormMutation
>;
export const createForeignNational = /* GraphQL */ `mutation CreateForeignNational(
  $input: CreateForeignNationalInput!
  $condition: ModelForeignNationalConditionInput
) {
  createForeignNational(input: $input, condition: $condition) {
    type
    id
    createdBy
    slug
    userAgreementAcknowledged
    userAgreementAcknowledgementDate
    userAgreementAcknowledgementText
    hasLoggedIn
    onboardingSections {
      background
      contact
      employment
      family
      immigration
      personal
      __typename
    }
    completedOnboardingQuestionsBy
    email
    emailPersonal
    emailWork
    usMailingAddress {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    usResidentialAddress {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    lastAddressOutsideUS {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    username
    avatar {
      version
      __typename
    }
    firstname
    middlename
    lastname
    nickname
    employeeId
    additionalFirstnames
    additionalMiddlenames
    additionalLastnames
    lowerFirst
    lowerLast
    lowerFull
    maritalStatus
    spouse
    dependents
    phone
    phoneWork
    companyID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    companyNationalNumber
    mostRecentlyInvited
    archived
    workLocation {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    relativesAsSource {
      nextToken
      __typename
    }
    relativesAsTarget {
      nextToken
      __typename
    }
    relatives
    relativeAdmins
    immigrationStatus {
      status
      doesNotExpire
      expiration
      __typename
    }
    immigrationVisaStatus
    visaExpiration
    nonImmigrantVisaNumber
    visaIssueDate
    visaConsulate
    immigrantVisaApplicant
    immigrantPetitionEverFiled
    j1j2 {
      hasHad
      start
      end
      __typename
    }
    hasHadI485Filed {
      value
      followPrompt
      followValue
      __typename
    }
    hasPendingETA9089
    hasApprovedI140 {
      hasApproved
      classification
      employmentBasedCategory
      priorityDate
      petitionerI140
      __typename
    }
    aosFilingEligible
    hasValidOrExpiredEAD
    hasPendingUSCISApplication
    hasHadVisaPetitionRevokedOrDenied
    hasBeenArrestedSinceLastUSEntry
    criminalHistory {
      tortureGenocide
      killing
      severeInjuring
      nonconsensualSex
      religiousBelief
      __typename
    }
    hasTransportedWeapons
    hasParticipatedInArmedGroup
    hasDetailedPerson
    hasUsedWeapons
    hasWeaponsTraining
    hasCriminalOffence
    hasViolatedVisaTerms
    isInRemovalProceedings {
      value
      reason
      __typename
    }
    hasBeenEmployedSinceLastAdmitted {
      value
      reason
      __typename
    }
    citizenshipCountry
    birthCountry
    birthState
    birthDate
    birthCity
    jobDescriptionID
    jobDescription {
      companyID
      id
      archived
      type
      foreignNationalID
      title
      officialTitle
      degrees
      requiresBachelors
      requiresMasters
      requiresPhd
      dotNumber
      caseSocCode
      duties
      jobURL
      majors
      specialRequirements
      yearsGeneralExperience
      objectiveSkillSetsRequired
      offeredSalary
      certificationLicenses
      travelIsRequired
      travelPercentage
      travelDomestic
      travelInternational
      supervisesOthers
      supervisesOthersCount
      supervisesTitles
      supervisorTitle
      canWorkFromHome
      uploadedDescriptionID
      createdAt
      updatedAt
      __typename
    }
    nivMaxout
    offeredSalary {
      currency
      amount
      period
      __typename
    }
    isRemote
    loginStatus {
      isEnabled
      status
      __typename
    }
    hasNonUSPassport
    passportGender
    passportIssueDate
    passportExpirationDate
    passportExpirationReminderSentForDate
    passportNumber
    passportCountry
    usSSN
    hasSSN
    aNumber
    lastEntryUS
    i94ArrivalDepartureRecordNumber
    sevisNumber
    eadNumber
    cases {
      nextToken
      __typename
    }
    sponsoredCases {
      nextToken
      __typename
    }
    processRequests {
      nextToken
      __typename
    }
    tasks {
      nextToken
      __typename
    }
    files {
      nextToken
      __typename
    }
    fileRequirements {
      type
      fileType
      fileCategory
      fileInstruction
      defaultStorage
      visibility
      assignedToID
      isAssignedToLegalAssistants
      expirationDateRequired
      issueDateRequired
      dueDateRequired
      isApproved
      isRequested
      hidden
      durationOfStatus
      __typename
    }
    fileRequirementsManipulated
    test
    notes
    companyName
    immigrationCurrentStatus
    immigrationStatusExpiration
    employmentBasedCategory
    priorityDate
    eadExpDate
    I797ExpDate
    visaExpDate
    reportEntries {
      nextToken
      __typename
    }
    chargeabilityCountry
    birthCountryCode
    socCode
    firstEntryUS
    taxTrackingF1J1
    citizenshipEligibilityDate
    startDate
    legalTeamIDs
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateForeignNationalMutationVariables,
  APITypes.CreateForeignNationalMutation
>;
export const updateForeignNational = /* GraphQL */ `mutation UpdateForeignNational(
  $input: UpdateForeignNationalInput!
  $condition: ModelForeignNationalConditionInput
) {
  updateForeignNational(input: $input, condition: $condition) {
    type
    id
    createdBy
    slug
    userAgreementAcknowledged
    userAgreementAcknowledgementDate
    userAgreementAcknowledgementText
    hasLoggedIn
    onboardingSections {
      background
      contact
      employment
      family
      immigration
      personal
      __typename
    }
    completedOnboardingQuestionsBy
    email
    emailPersonal
    emailWork
    usMailingAddress {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    usResidentialAddress {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    lastAddressOutsideUS {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    username
    avatar {
      version
      __typename
    }
    firstname
    middlename
    lastname
    nickname
    employeeId
    additionalFirstnames
    additionalMiddlenames
    additionalLastnames
    lowerFirst
    lowerLast
    lowerFull
    maritalStatus
    spouse
    dependents
    phone
    phoneWork
    companyID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    companyNationalNumber
    mostRecentlyInvited
    archived
    workLocation {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    relativesAsSource {
      nextToken
      __typename
    }
    relativesAsTarget {
      nextToken
      __typename
    }
    relatives
    relativeAdmins
    immigrationStatus {
      status
      doesNotExpire
      expiration
      __typename
    }
    immigrationVisaStatus
    visaExpiration
    nonImmigrantVisaNumber
    visaIssueDate
    visaConsulate
    immigrantVisaApplicant
    immigrantPetitionEverFiled
    j1j2 {
      hasHad
      start
      end
      __typename
    }
    hasHadI485Filed {
      value
      followPrompt
      followValue
      __typename
    }
    hasPendingETA9089
    hasApprovedI140 {
      hasApproved
      classification
      employmentBasedCategory
      priorityDate
      petitionerI140
      __typename
    }
    aosFilingEligible
    hasValidOrExpiredEAD
    hasPendingUSCISApplication
    hasHadVisaPetitionRevokedOrDenied
    hasBeenArrestedSinceLastUSEntry
    criminalHistory {
      tortureGenocide
      killing
      severeInjuring
      nonconsensualSex
      religiousBelief
      __typename
    }
    hasTransportedWeapons
    hasParticipatedInArmedGroup
    hasDetailedPerson
    hasUsedWeapons
    hasWeaponsTraining
    hasCriminalOffence
    hasViolatedVisaTerms
    isInRemovalProceedings {
      value
      reason
      __typename
    }
    hasBeenEmployedSinceLastAdmitted {
      value
      reason
      __typename
    }
    citizenshipCountry
    birthCountry
    birthState
    birthDate
    birthCity
    jobDescriptionID
    jobDescription {
      companyID
      id
      archived
      type
      foreignNationalID
      title
      officialTitle
      degrees
      requiresBachelors
      requiresMasters
      requiresPhd
      dotNumber
      caseSocCode
      duties
      jobURL
      majors
      specialRequirements
      yearsGeneralExperience
      objectiveSkillSetsRequired
      offeredSalary
      certificationLicenses
      travelIsRequired
      travelPercentage
      travelDomestic
      travelInternational
      supervisesOthers
      supervisesOthersCount
      supervisesTitles
      supervisorTitle
      canWorkFromHome
      uploadedDescriptionID
      createdAt
      updatedAt
      __typename
    }
    nivMaxout
    offeredSalary {
      currency
      amount
      period
      __typename
    }
    isRemote
    loginStatus {
      isEnabled
      status
      __typename
    }
    hasNonUSPassport
    passportGender
    passportIssueDate
    passportExpirationDate
    passportExpirationReminderSentForDate
    passportNumber
    passportCountry
    usSSN
    hasSSN
    aNumber
    lastEntryUS
    i94ArrivalDepartureRecordNumber
    sevisNumber
    eadNumber
    cases {
      nextToken
      __typename
    }
    sponsoredCases {
      nextToken
      __typename
    }
    processRequests {
      nextToken
      __typename
    }
    tasks {
      nextToken
      __typename
    }
    files {
      nextToken
      __typename
    }
    fileRequirements {
      type
      fileType
      fileCategory
      fileInstruction
      defaultStorage
      visibility
      assignedToID
      isAssignedToLegalAssistants
      expirationDateRequired
      issueDateRequired
      dueDateRequired
      isApproved
      isRequested
      hidden
      durationOfStatus
      __typename
    }
    fileRequirementsManipulated
    test
    notes
    companyName
    immigrationCurrentStatus
    immigrationStatusExpiration
    employmentBasedCategory
    priorityDate
    eadExpDate
    I797ExpDate
    visaExpDate
    reportEntries {
      nextToken
      __typename
    }
    chargeabilityCountry
    birthCountryCode
    socCode
    firstEntryUS
    taxTrackingF1J1
    citizenshipEligibilityDate
    startDate
    legalTeamIDs
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateForeignNationalMutationVariables,
  APITypes.UpdateForeignNationalMutation
>;
export const deleteForeignNational = /* GraphQL */ `mutation DeleteForeignNational(
  $input: DeleteForeignNationalInput!
  $condition: ModelForeignNationalConditionInput
) {
  deleteForeignNational(input: $input, condition: $condition) {
    type
    id
    createdBy
    slug
    userAgreementAcknowledged
    userAgreementAcknowledgementDate
    userAgreementAcknowledgementText
    hasLoggedIn
    onboardingSections {
      background
      contact
      employment
      family
      immigration
      personal
      __typename
    }
    completedOnboardingQuestionsBy
    email
    emailPersonal
    emailWork
    usMailingAddress {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    usResidentialAddress {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    lastAddressOutsideUS {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    username
    avatar {
      version
      __typename
    }
    firstname
    middlename
    lastname
    nickname
    employeeId
    additionalFirstnames
    additionalMiddlenames
    additionalLastnames
    lowerFirst
    lowerLast
    lowerFull
    maritalStatus
    spouse
    dependents
    phone
    phoneWork
    companyID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    companyNationalNumber
    mostRecentlyInvited
    archived
    workLocation {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    relativesAsSource {
      nextToken
      __typename
    }
    relativesAsTarget {
      nextToken
      __typename
    }
    relatives
    relativeAdmins
    immigrationStatus {
      status
      doesNotExpire
      expiration
      __typename
    }
    immigrationVisaStatus
    visaExpiration
    nonImmigrantVisaNumber
    visaIssueDate
    visaConsulate
    immigrantVisaApplicant
    immigrantPetitionEverFiled
    j1j2 {
      hasHad
      start
      end
      __typename
    }
    hasHadI485Filed {
      value
      followPrompt
      followValue
      __typename
    }
    hasPendingETA9089
    hasApprovedI140 {
      hasApproved
      classification
      employmentBasedCategory
      priorityDate
      petitionerI140
      __typename
    }
    aosFilingEligible
    hasValidOrExpiredEAD
    hasPendingUSCISApplication
    hasHadVisaPetitionRevokedOrDenied
    hasBeenArrestedSinceLastUSEntry
    criminalHistory {
      tortureGenocide
      killing
      severeInjuring
      nonconsensualSex
      religiousBelief
      __typename
    }
    hasTransportedWeapons
    hasParticipatedInArmedGroup
    hasDetailedPerson
    hasUsedWeapons
    hasWeaponsTraining
    hasCriminalOffence
    hasViolatedVisaTerms
    isInRemovalProceedings {
      value
      reason
      __typename
    }
    hasBeenEmployedSinceLastAdmitted {
      value
      reason
      __typename
    }
    citizenshipCountry
    birthCountry
    birthState
    birthDate
    birthCity
    jobDescriptionID
    jobDescription {
      companyID
      id
      archived
      type
      foreignNationalID
      title
      officialTitle
      degrees
      requiresBachelors
      requiresMasters
      requiresPhd
      dotNumber
      caseSocCode
      duties
      jobURL
      majors
      specialRequirements
      yearsGeneralExperience
      objectiveSkillSetsRequired
      offeredSalary
      certificationLicenses
      travelIsRequired
      travelPercentage
      travelDomestic
      travelInternational
      supervisesOthers
      supervisesOthersCount
      supervisesTitles
      supervisorTitle
      canWorkFromHome
      uploadedDescriptionID
      createdAt
      updatedAt
      __typename
    }
    nivMaxout
    offeredSalary {
      currency
      amount
      period
      __typename
    }
    isRemote
    loginStatus {
      isEnabled
      status
      __typename
    }
    hasNonUSPassport
    passportGender
    passportIssueDate
    passportExpirationDate
    passportExpirationReminderSentForDate
    passportNumber
    passportCountry
    usSSN
    hasSSN
    aNumber
    lastEntryUS
    i94ArrivalDepartureRecordNumber
    sevisNumber
    eadNumber
    cases {
      nextToken
      __typename
    }
    sponsoredCases {
      nextToken
      __typename
    }
    processRequests {
      nextToken
      __typename
    }
    tasks {
      nextToken
      __typename
    }
    files {
      nextToken
      __typename
    }
    fileRequirements {
      type
      fileType
      fileCategory
      fileInstruction
      defaultStorage
      visibility
      assignedToID
      isAssignedToLegalAssistants
      expirationDateRequired
      issueDateRequired
      dueDateRequired
      isApproved
      isRequested
      hidden
      durationOfStatus
      __typename
    }
    fileRequirementsManipulated
    test
    notes
    companyName
    immigrationCurrentStatus
    immigrationStatusExpiration
    employmentBasedCategory
    priorityDate
    eadExpDate
    I797ExpDate
    visaExpDate
    reportEntries {
      nextToken
      __typename
    }
    chargeabilityCountry
    birthCountryCode
    socCode
    firstEntryUS
    taxTrackingF1J1
    citizenshipEligibilityDate
    startDate
    legalTeamIDs
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteForeignNationalMutationVariables,
  APITypes.DeleteForeignNationalMutation
>;
export const createEmployer = /* GraphQL */ `mutation CreateEmployer(
  $input: CreateEmployerInput!
  $condition: ModelEmployerConditionInput
) {
  createEmployer(input: $input, condition: $condition) {
    id
    createdBy
    slug
    userAgreementAcknowledged
    userAgreementAcknowledgementDate
    userAgreementAcknowledgementText
    hasLoggedIn
    type
    email
    personalEmail
    newsletterModalViewCount
    username
    avatar {
      version
      __typename
    }
    firstname
    middlename
    lastname
    lowerFirst
    lowerLast
    lowerFull
    address
    phone
    personalPhone
    title
    companyIDs
    companies {
      nextToken
      __typename
    }
    adminCompanies {
      nextToken
      __typename
    }
    invoicingContactCompanies {
      nextToken
      __typename
    }
    primaryContactCompanies {
      nextToken
      __typename
    }
    seniorContactCompanies {
      nextToken
      __typename
    }
    signatoryContactCompanies {
      nextToken
      __typename
    }
    sponsoredCases {
      nextToken
      __typename
    }
    contributorCases {
      nextToken
      __typename
    }
    processRequestAssignments {
      nextToken
      __typename
    }
    tasks {
      nextToken
      __typename
    }
    hasCompletedOnboardingQuestions
    recentlyViewedCases
    mostRecentlyInvited
    archived
    loginStatus {
      isEnabled
      status
      __typename
    }
    customTemplates {
      nextToken
      __typename
    }
    invoicingContactCompanyIDs
    isInvoicingContact
    primaryContactCompanyIDs
    isPrimaryContact
    seniorContactCompanyIDs
    isSeniorContact
    signatoryContactCompanyIDs
    isSignatoryContact
    assignedCaseIDs
    nationalsWithOpenCases
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEmployerMutationVariables,
  APITypes.CreateEmployerMutation
>;
export const updateEmployer = /* GraphQL */ `mutation UpdateEmployer(
  $input: UpdateEmployerInput!
  $condition: ModelEmployerConditionInput
) {
  updateEmployer(input: $input, condition: $condition) {
    id
    createdBy
    slug
    userAgreementAcknowledged
    userAgreementAcknowledgementDate
    userAgreementAcknowledgementText
    hasLoggedIn
    type
    email
    personalEmail
    newsletterModalViewCount
    username
    avatar {
      version
      __typename
    }
    firstname
    middlename
    lastname
    lowerFirst
    lowerLast
    lowerFull
    address
    phone
    personalPhone
    title
    companyIDs
    companies {
      nextToken
      __typename
    }
    adminCompanies {
      nextToken
      __typename
    }
    invoicingContactCompanies {
      nextToken
      __typename
    }
    primaryContactCompanies {
      nextToken
      __typename
    }
    seniorContactCompanies {
      nextToken
      __typename
    }
    signatoryContactCompanies {
      nextToken
      __typename
    }
    sponsoredCases {
      nextToken
      __typename
    }
    contributorCases {
      nextToken
      __typename
    }
    processRequestAssignments {
      nextToken
      __typename
    }
    tasks {
      nextToken
      __typename
    }
    hasCompletedOnboardingQuestions
    recentlyViewedCases
    mostRecentlyInvited
    archived
    loginStatus {
      isEnabled
      status
      __typename
    }
    customTemplates {
      nextToken
      __typename
    }
    invoicingContactCompanyIDs
    isInvoicingContact
    primaryContactCompanyIDs
    isPrimaryContact
    seniorContactCompanyIDs
    isSeniorContact
    signatoryContactCompanyIDs
    isSignatoryContact
    assignedCaseIDs
    nationalsWithOpenCases
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEmployerMutationVariables,
  APITypes.UpdateEmployerMutation
>;
export const deleteEmployer = /* GraphQL */ `mutation DeleteEmployer(
  $input: DeleteEmployerInput!
  $condition: ModelEmployerConditionInput
) {
  deleteEmployer(input: $input, condition: $condition) {
    id
    createdBy
    slug
    userAgreementAcknowledged
    userAgreementAcknowledgementDate
    userAgreementAcknowledgementText
    hasLoggedIn
    type
    email
    personalEmail
    newsletterModalViewCount
    username
    avatar {
      version
      __typename
    }
    firstname
    middlename
    lastname
    lowerFirst
    lowerLast
    lowerFull
    address
    phone
    personalPhone
    title
    companyIDs
    companies {
      nextToken
      __typename
    }
    adminCompanies {
      nextToken
      __typename
    }
    invoicingContactCompanies {
      nextToken
      __typename
    }
    primaryContactCompanies {
      nextToken
      __typename
    }
    seniorContactCompanies {
      nextToken
      __typename
    }
    signatoryContactCompanies {
      nextToken
      __typename
    }
    sponsoredCases {
      nextToken
      __typename
    }
    contributorCases {
      nextToken
      __typename
    }
    processRequestAssignments {
      nextToken
      __typename
    }
    tasks {
      nextToken
      __typename
    }
    hasCompletedOnboardingQuestions
    recentlyViewedCases
    mostRecentlyInvited
    archived
    loginStatus {
      isEnabled
      status
      __typename
    }
    customTemplates {
      nextToken
      __typename
    }
    invoicingContactCompanyIDs
    isInvoicingContact
    primaryContactCompanyIDs
    isPrimaryContact
    seniorContactCompanyIDs
    isSeniorContact
    signatoryContactCompanyIDs
    isSignatoryContact
    assignedCaseIDs
    nationalsWithOpenCases
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEmployerMutationVariables,
  APITypes.DeleteEmployerMutation
>;
export const createTeamMember = /* GraphQL */ `mutation CreateTeamMember(
  $input: CreateTeamMemberInput!
  $condition: ModelTeamMemberConditionInput
) {
  createTeamMember(input: $input, condition: $condition) {
    id
    createdBy
    slug
    userAgreementAcknowledged
    userAgreementAcknowledgementDate
    userAgreementAcknowledgementText
    hasLoggedIn
    type
    email
    username
    avatar {
      version
      __typename
    }
    firstname
    middlename
    lastname
    lowerFirst
    lowerLast
    lowerFull
    phone
    position
    title
    licensingAuthority
    stateBarNumber
    isAdmin
    manager {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    managerID
    attorneyAssignments {
      nextToken
      __typename
    }
    paralegalAssignments {
      nextToken
      __typename
    }
    accountManagerAssignments {
      nextToken
      __typename
    }
    attorneyCases {
      nextToken
      __typename
    }
    caseManagerCases {
      nextToken
      __typename
    }
    contributorCases {
      nextToken
      __typename
    }
    processRequestAssignments {
      nextToken
      __typename
    }
    tasks {
      nextToken
      __typename
    }
    mostRecentlyInvited
    archived
    loginStatus {
      isEnabled
      status
      __typename
    }
    recentlyViewedCases
    customTemplates {
      nextToken
      __typename
    }
    nationalsWithOpenCases
    companiesAssignedTo
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTeamMemberMutationVariables,
  APITypes.CreateTeamMemberMutation
>;
export const updateTeamMember = /* GraphQL */ `mutation UpdateTeamMember(
  $input: UpdateTeamMemberInput!
  $condition: ModelTeamMemberConditionInput
) {
  updateTeamMember(input: $input, condition: $condition) {
    id
    createdBy
    slug
    userAgreementAcknowledged
    userAgreementAcknowledgementDate
    userAgreementAcknowledgementText
    hasLoggedIn
    type
    email
    username
    avatar {
      version
      __typename
    }
    firstname
    middlename
    lastname
    lowerFirst
    lowerLast
    lowerFull
    phone
    position
    title
    licensingAuthority
    stateBarNumber
    isAdmin
    manager {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    managerID
    attorneyAssignments {
      nextToken
      __typename
    }
    paralegalAssignments {
      nextToken
      __typename
    }
    accountManagerAssignments {
      nextToken
      __typename
    }
    attorneyCases {
      nextToken
      __typename
    }
    caseManagerCases {
      nextToken
      __typename
    }
    contributorCases {
      nextToken
      __typename
    }
    processRequestAssignments {
      nextToken
      __typename
    }
    tasks {
      nextToken
      __typename
    }
    mostRecentlyInvited
    archived
    loginStatus {
      isEnabled
      status
      __typename
    }
    recentlyViewedCases
    customTemplates {
      nextToken
      __typename
    }
    nationalsWithOpenCases
    companiesAssignedTo
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTeamMemberMutationVariables,
  APITypes.UpdateTeamMemberMutation
>;
export const deleteTeamMember = /* GraphQL */ `mutation DeleteTeamMember(
  $input: DeleteTeamMemberInput!
  $condition: ModelTeamMemberConditionInput
) {
  deleteTeamMember(input: $input, condition: $condition) {
    id
    createdBy
    slug
    userAgreementAcknowledged
    userAgreementAcknowledgementDate
    userAgreementAcknowledgementText
    hasLoggedIn
    type
    email
    username
    avatar {
      version
      __typename
    }
    firstname
    middlename
    lastname
    lowerFirst
    lowerLast
    lowerFull
    phone
    position
    title
    licensingAuthority
    stateBarNumber
    isAdmin
    manager {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    managerID
    attorneyAssignments {
      nextToken
      __typename
    }
    paralegalAssignments {
      nextToken
      __typename
    }
    accountManagerAssignments {
      nextToken
      __typename
    }
    attorneyCases {
      nextToken
      __typename
    }
    caseManagerCases {
      nextToken
      __typename
    }
    contributorCases {
      nextToken
      __typename
    }
    processRequestAssignments {
      nextToken
      __typename
    }
    tasks {
      nextToken
      __typename
    }
    mostRecentlyInvited
    archived
    loginStatus {
      isEnabled
      status
      __typename
    }
    recentlyViewedCases
    customTemplates {
      nextToken
      __typename
    }
    nationalsWithOpenCases
    companiesAssignedTo
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTeamMemberMutationVariables,
  APITypes.DeleteTeamMemberMutation
>;
export const createFamilyRelationship = /* GraphQL */ `mutation CreateFamilyRelationship(
  $input: CreateFamilyRelationshipInput!
  $condition: ModelFamilyRelationshipConditionInput
) {
  createFamilyRelationship(input: $input, condition: $condition) {
    id
    sourceID
    source {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    targetID
    target {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    type
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFamilyRelationshipMutationVariables,
  APITypes.CreateFamilyRelationshipMutation
>;
export const updateFamilyRelationship = /* GraphQL */ `mutation UpdateFamilyRelationship(
  $input: UpdateFamilyRelationshipInput!
  $condition: ModelFamilyRelationshipConditionInput
) {
  updateFamilyRelationship(input: $input, condition: $condition) {
    id
    sourceID
    source {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    targetID
    target {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    type
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFamilyRelationshipMutationVariables,
  APITypes.UpdateFamilyRelationshipMutation
>;
export const deleteFamilyRelationship = /* GraphQL */ `mutation DeleteFamilyRelationship(
  $input: DeleteFamilyRelationshipInput!
  $condition: ModelFamilyRelationshipConditionInput
) {
  deleteFamilyRelationship(input: $input, condition: $condition) {
    id
    sourceID
    source {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    targetID
    target {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    type
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFamilyRelationshipMutationVariables,
  APITypes.DeleteFamilyRelationshipMutation
>;
export const createAttorneyAssignment = /* GraphQL */ `mutation CreateAttorneyAssignment(
  $input: CreateAttorneyAssignmentInput!
  $condition: ModelAttorneyAssignmentConditionInput
) {
  createAttorneyAssignment(input: $input, condition: $condition) {
    id
    companyID
    attorneyID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    attorney {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAttorneyAssignmentMutationVariables,
  APITypes.CreateAttorneyAssignmentMutation
>;
export const updateAttorneyAssignment = /* GraphQL */ `mutation UpdateAttorneyAssignment(
  $input: UpdateAttorneyAssignmentInput!
  $condition: ModelAttorneyAssignmentConditionInput
) {
  updateAttorneyAssignment(input: $input, condition: $condition) {
    id
    companyID
    attorneyID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    attorney {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAttorneyAssignmentMutationVariables,
  APITypes.UpdateAttorneyAssignmentMutation
>;
export const deleteAttorneyAssignment = /* GraphQL */ `mutation DeleteAttorneyAssignment(
  $input: DeleteAttorneyAssignmentInput!
  $condition: ModelAttorneyAssignmentConditionInput
) {
  deleteAttorneyAssignment(input: $input, condition: $condition) {
    id
    companyID
    attorneyID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    attorney {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAttorneyAssignmentMutationVariables,
  APITypes.DeleteAttorneyAssignmentMutation
>;
export const createParalegalAssignment = /* GraphQL */ `mutation CreateParalegalAssignment(
  $input: CreateParalegalAssignmentInput!
  $condition: ModelParalegalAssignmentConditionInput
) {
  createParalegalAssignment(input: $input, condition: $condition) {
    id
    companyID
    paralegalID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    paralegal {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateParalegalAssignmentMutationVariables,
  APITypes.CreateParalegalAssignmentMutation
>;
export const updateParalegalAssignment = /* GraphQL */ `mutation UpdateParalegalAssignment(
  $input: UpdateParalegalAssignmentInput!
  $condition: ModelParalegalAssignmentConditionInput
) {
  updateParalegalAssignment(input: $input, condition: $condition) {
    id
    companyID
    paralegalID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    paralegal {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateParalegalAssignmentMutationVariables,
  APITypes.UpdateParalegalAssignmentMutation
>;
export const deleteParalegalAssignment = /* GraphQL */ `mutation DeleteParalegalAssignment(
  $input: DeleteParalegalAssignmentInput!
  $condition: ModelParalegalAssignmentConditionInput
) {
  deleteParalegalAssignment(input: $input, condition: $condition) {
    id
    companyID
    paralegalID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    paralegal {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteParalegalAssignmentMutationVariables,
  APITypes.DeleteParalegalAssignmentMutation
>;
export const createEmployerAssignment = /* GraphQL */ `mutation CreateEmployerAssignment(
  $input: CreateEmployerAssignmentInput!
  $condition: ModelEmployerAssignmentConditionInput
) {
  createEmployerAssignment(input: $input, condition: $condition) {
    id
    companyID
    employerID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEmployerAssignmentMutationVariables,
  APITypes.CreateEmployerAssignmentMutation
>;
export const updateEmployerAssignment = /* GraphQL */ `mutation UpdateEmployerAssignment(
  $input: UpdateEmployerAssignmentInput!
  $condition: ModelEmployerAssignmentConditionInput
) {
  updateEmployerAssignment(input: $input, condition: $condition) {
    id
    companyID
    employerID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEmployerAssignmentMutationVariables,
  APITypes.UpdateEmployerAssignmentMutation
>;
export const deleteEmployerAssignment = /* GraphQL */ `mutation DeleteEmployerAssignment(
  $input: DeleteEmployerAssignmentInput!
  $condition: ModelEmployerAssignmentConditionInput
) {
  deleteEmployerAssignment(input: $input, condition: $condition) {
    id
    companyID
    employerID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEmployerAssignmentMutationVariables,
  APITypes.DeleteEmployerAssignmentMutation
>;
export const createEmployerAdminAssignment = /* GraphQL */ `mutation CreateEmployerAdminAssignment(
  $input: CreateEmployerAdminAssignmentInput!
  $condition: ModelEmployerAdminAssignmentConditionInput
) {
  createEmployerAdminAssignment(input: $input, condition: $condition) {
    id
    companyID
    employerID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEmployerAdminAssignmentMutationVariables,
  APITypes.CreateEmployerAdminAssignmentMutation
>;
export const updateEmployerAdminAssignment = /* GraphQL */ `mutation UpdateEmployerAdminAssignment(
  $input: UpdateEmployerAdminAssignmentInput!
  $condition: ModelEmployerAdminAssignmentConditionInput
) {
  updateEmployerAdminAssignment(input: $input, condition: $condition) {
    id
    companyID
    employerID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEmployerAdminAssignmentMutationVariables,
  APITypes.UpdateEmployerAdminAssignmentMutation
>;
export const deleteEmployerAdminAssignment = /* GraphQL */ `mutation DeleteEmployerAdminAssignment(
  $input: DeleteEmployerAdminAssignmentInput!
  $condition: ModelEmployerAdminAssignmentConditionInput
) {
  deleteEmployerAdminAssignment(input: $input, condition: $condition) {
    id
    companyID
    employerID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEmployerAdminAssignmentMutationVariables,
  APITypes.DeleteEmployerAdminAssignmentMutation
>;
export const createPrimaryContact = /* GraphQL */ `mutation CreatePrimaryContact(
  $input: CreatePrimaryContactInput!
  $condition: ModelPrimaryContactConditionInput
) {
  createPrimaryContact(input: $input, condition: $condition) {
    id
    companyID
    employerID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePrimaryContactMutationVariables,
  APITypes.CreatePrimaryContactMutation
>;
export const updatePrimaryContact = /* GraphQL */ `mutation UpdatePrimaryContact(
  $input: UpdatePrimaryContactInput!
  $condition: ModelPrimaryContactConditionInput
) {
  updatePrimaryContact(input: $input, condition: $condition) {
    id
    companyID
    employerID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePrimaryContactMutationVariables,
  APITypes.UpdatePrimaryContactMutation
>;
export const deletePrimaryContact = /* GraphQL */ `mutation DeletePrimaryContact(
  $input: DeletePrimaryContactInput!
  $condition: ModelPrimaryContactConditionInput
) {
  deletePrimaryContact(input: $input, condition: $condition) {
    id
    companyID
    employerID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePrimaryContactMutationVariables,
  APITypes.DeletePrimaryContactMutation
>;
export const createSeniorContact = /* GraphQL */ `mutation CreateSeniorContact(
  $input: CreateSeniorContactInput!
  $condition: ModelSeniorContactConditionInput
) {
  createSeniorContact(input: $input, condition: $condition) {
    id
    companyID
    employerID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSeniorContactMutationVariables,
  APITypes.CreateSeniorContactMutation
>;
export const updateSeniorContact = /* GraphQL */ `mutation UpdateSeniorContact(
  $input: UpdateSeniorContactInput!
  $condition: ModelSeniorContactConditionInput
) {
  updateSeniorContact(input: $input, condition: $condition) {
    id
    companyID
    employerID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSeniorContactMutationVariables,
  APITypes.UpdateSeniorContactMutation
>;
export const deleteSeniorContact = /* GraphQL */ `mutation DeleteSeniorContact(
  $input: DeleteSeniorContactInput!
  $condition: ModelSeniorContactConditionInput
) {
  deleteSeniorContact(input: $input, condition: $condition) {
    id
    companyID
    employerID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSeniorContactMutationVariables,
  APITypes.DeleteSeniorContactMutation
>;
export const createInvoicingContact = /* GraphQL */ `mutation CreateInvoicingContact(
  $input: CreateInvoicingContactInput!
  $condition: ModelInvoicingContactConditionInput
) {
  createInvoicingContact(input: $input, condition: $condition) {
    id
    companyID
    employerID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateInvoicingContactMutationVariables,
  APITypes.CreateInvoicingContactMutation
>;
export const updateInvoicingContact = /* GraphQL */ `mutation UpdateInvoicingContact(
  $input: UpdateInvoicingContactInput!
  $condition: ModelInvoicingContactConditionInput
) {
  updateInvoicingContact(input: $input, condition: $condition) {
    id
    companyID
    employerID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateInvoicingContactMutationVariables,
  APITypes.UpdateInvoicingContactMutation
>;
export const deleteInvoicingContact = /* GraphQL */ `mutation DeleteInvoicingContact(
  $input: DeleteInvoicingContactInput!
  $condition: ModelInvoicingContactConditionInput
) {
  deleteInvoicingContact(input: $input, condition: $condition) {
    id
    companyID
    employerID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteInvoicingContactMutationVariables,
  APITypes.DeleteInvoicingContactMutation
>;
export const createSignatoryContact = /* GraphQL */ `mutation CreateSignatoryContact(
  $input: CreateSignatoryContactInput!
  $condition: ModelSignatoryContactConditionInput
) {
  createSignatoryContact(input: $input, condition: $condition) {
    id
    companyID
    employerID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSignatoryContactMutationVariables,
  APITypes.CreateSignatoryContactMutation
>;
export const updateSignatoryContact = /* GraphQL */ `mutation UpdateSignatoryContact(
  $input: UpdateSignatoryContactInput!
  $condition: ModelSignatoryContactConditionInput
) {
  updateSignatoryContact(input: $input, condition: $condition) {
    id
    companyID
    employerID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSignatoryContactMutationVariables,
  APITypes.UpdateSignatoryContactMutation
>;
export const deleteSignatoryContact = /* GraphQL */ `mutation DeleteSignatoryContact(
  $input: DeleteSignatoryContactInput!
  $condition: ModelSignatoryContactConditionInput
) {
  deleteSignatoryContact(input: $input, condition: $condition) {
    id
    companyID
    employerID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSignatoryContactMutationVariables,
  APITypes.DeleteSignatoryContactMutation
>;
export const createCompany = /* GraphQL */ `mutation CreateCompany(
  $input: CreateCompanyInput!
  $condition: ModelCompanyConditionInput
) {
  createCompany(input: $input, condition: $condition) {
    id
    name
    lowerName
    lowerNameKey
    displayCompanyName
    slug
    type
    logo {
      version
      __typename
    }
    domainWhitelist
    onboardingSections {
      companyInfo
      contactInfo
      companyPreferences
      immigrationPreferences
      paymentPreferences
      questions
      employeeInformation
      __typename
    }
    hasCompletedOnboardingQuestions
    completedOnboardingQuestionsBy
    isPartnerCompany
    isParent
    children {
      nextToken
      __typename
    }
    parent {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    parentID
    archived
    companyNumber
    nationalCount
    foreignNationals {
      nextToken
      __typename
    }
    assignedAttorneys {
      nextToken
      __typename
    }
    assignedParalegals {
      nextToken
      __typename
    }
    accountManagerID
    accountManager {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    assignedEmployers {
      nextToken
      __typename
    }
    assignedEmployerAdmins {
      nextToken
      __typename
    }
    invoicingContacts {
      nextToken
      __typename
    }
    primaryContacts {
      nextToken
      __typename
    }
    seniorContacts {
      nextToken
      __typename
    }
    signatoryContacts {
      nextToken
      __typename
    }
    data {
      id
      companyID
      preferredMailingAddress
      companyNameShowToFN
      companyCoversExpenseOfDependentPetitionsAndOrEADCards
      doingBusinessAs
      educationEvaluation
      employeesEmailMHAttorneysAndParalegalsDirectly
      fein
      fullTimeEmployeesInUS
      isH1BDependentEmloyer
      hasBeenWillfulViolator
      isHigherEd_20_USC_1001_a
      isHigherEdNonProfit_8_CFR_214_2_h_19_iii_B
      isHigherEdNonProfit_8_CFR_214_2_h_8_ii_F_2
      isNonProfitResearch_8_CFR_214_2_h_19_iii_C
      isNonProfitResearch_8_CFR_214_2_h_8_ii_F_3
      isQualifyingCapExempt_8_CFR_214_2_h_8_ii_F_4
      maintainsAWrittenImmigrationPolicy
      naicsCodeOfCompany
      partTimeEmployeesInUS
      paymentPreference
      permissionPowerAttorney
      permissionReleaseApprovalNotices
      permissionReleasePetitionsRFE
      permissionReleaseLCA
      permissionRelease9089
      phone
      placesEmployeesAtClientSitesForMoreThanACoupleOfDaysAtATime
      fax
      preferredShippingSpeedForDocuments
      shipOriginalApprovalNotices
      staffsEmployeesAtThirdPartyEndClientSites
      typeOfBusiness
      usesWageSurvey
      usesEVerify
      utilizePremiumProcessingService
      technologyReleaseLicenseRequirement
      yearCompanyWasFoundedInUS
      I9_audit_has_been_completed_in_past_18_months
      current_number_of_H1B_employees
      current_number_of_employees_on_L_visas
      other_visa_statuses_sponsored
      email_address_invoices_should_be_addressed_to
      name_invoices_should_be_addressed_to
      companyCoversExpenseOfDependentPetitions
      placesEmployeesAtClientSitesForMoreThan30DaysAtATime
      annualMeetingDate
      requiresMeetingReminder
      createdAt
      updatedAt
      __typename
    }
    processRequests {
      nextToken
      __typename
    }
    jobDescriptions {
      nextToken
      __typename
    }
    files {
      nextToken
      __typename
    }
    fileRequirements {
      type
      fileType
      fileCategory
      fileInstruction
      defaultStorage
      visibility
      assignedToID
      isAssignedToLegalAssistants
      expirationDateRequired
      issueDateRequired
      dueDateRequired
      isApproved
      isRequested
      hidden
      durationOfStatus
      __typename
    }
    cases {
      nextToken
      __typename
    }
    openCaseCount
    closedCaseCount
    completedCaseCount
    legalTeamIDs
    notes
    petitionerParagraph
    reportEntries {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    companyDataId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCompanyMutationVariables,
  APITypes.CreateCompanyMutation
>;
export const updateCompany = /* GraphQL */ `mutation UpdateCompany(
  $input: UpdateCompanyInput!
  $condition: ModelCompanyConditionInput
) {
  updateCompany(input: $input, condition: $condition) {
    id
    name
    lowerName
    lowerNameKey
    displayCompanyName
    slug
    type
    logo {
      version
      __typename
    }
    domainWhitelist
    onboardingSections {
      companyInfo
      contactInfo
      companyPreferences
      immigrationPreferences
      paymentPreferences
      questions
      employeeInformation
      __typename
    }
    hasCompletedOnboardingQuestions
    completedOnboardingQuestionsBy
    isPartnerCompany
    isParent
    children {
      nextToken
      __typename
    }
    parent {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    parentID
    archived
    companyNumber
    nationalCount
    foreignNationals {
      nextToken
      __typename
    }
    assignedAttorneys {
      nextToken
      __typename
    }
    assignedParalegals {
      nextToken
      __typename
    }
    accountManagerID
    accountManager {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    assignedEmployers {
      nextToken
      __typename
    }
    assignedEmployerAdmins {
      nextToken
      __typename
    }
    invoicingContacts {
      nextToken
      __typename
    }
    primaryContacts {
      nextToken
      __typename
    }
    seniorContacts {
      nextToken
      __typename
    }
    signatoryContacts {
      nextToken
      __typename
    }
    data {
      id
      companyID
      preferredMailingAddress
      companyNameShowToFN
      companyCoversExpenseOfDependentPetitionsAndOrEADCards
      doingBusinessAs
      educationEvaluation
      employeesEmailMHAttorneysAndParalegalsDirectly
      fein
      fullTimeEmployeesInUS
      isH1BDependentEmloyer
      hasBeenWillfulViolator
      isHigherEd_20_USC_1001_a
      isHigherEdNonProfit_8_CFR_214_2_h_19_iii_B
      isHigherEdNonProfit_8_CFR_214_2_h_8_ii_F_2
      isNonProfitResearch_8_CFR_214_2_h_19_iii_C
      isNonProfitResearch_8_CFR_214_2_h_8_ii_F_3
      isQualifyingCapExempt_8_CFR_214_2_h_8_ii_F_4
      maintainsAWrittenImmigrationPolicy
      naicsCodeOfCompany
      partTimeEmployeesInUS
      paymentPreference
      permissionPowerAttorney
      permissionReleaseApprovalNotices
      permissionReleasePetitionsRFE
      permissionReleaseLCA
      permissionRelease9089
      phone
      placesEmployeesAtClientSitesForMoreThanACoupleOfDaysAtATime
      fax
      preferredShippingSpeedForDocuments
      shipOriginalApprovalNotices
      staffsEmployeesAtThirdPartyEndClientSites
      typeOfBusiness
      usesWageSurvey
      usesEVerify
      utilizePremiumProcessingService
      technologyReleaseLicenseRequirement
      yearCompanyWasFoundedInUS
      I9_audit_has_been_completed_in_past_18_months
      current_number_of_H1B_employees
      current_number_of_employees_on_L_visas
      other_visa_statuses_sponsored
      email_address_invoices_should_be_addressed_to
      name_invoices_should_be_addressed_to
      companyCoversExpenseOfDependentPetitions
      placesEmployeesAtClientSitesForMoreThan30DaysAtATime
      annualMeetingDate
      requiresMeetingReminder
      createdAt
      updatedAt
      __typename
    }
    processRequests {
      nextToken
      __typename
    }
    jobDescriptions {
      nextToken
      __typename
    }
    files {
      nextToken
      __typename
    }
    fileRequirements {
      type
      fileType
      fileCategory
      fileInstruction
      defaultStorage
      visibility
      assignedToID
      isAssignedToLegalAssistants
      expirationDateRequired
      issueDateRequired
      dueDateRequired
      isApproved
      isRequested
      hidden
      durationOfStatus
      __typename
    }
    cases {
      nextToken
      __typename
    }
    openCaseCount
    closedCaseCount
    completedCaseCount
    legalTeamIDs
    notes
    petitionerParagraph
    reportEntries {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    companyDataId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCompanyMutationVariables,
  APITypes.UpdateCompanyMutation
>;
export const deleteCompany = /* GraphQL */ `mutation DeleteCompany(
  $input: DeleteCompanyInput!
  $condition: ModelCompanyConditionInput
) {
  deleteCompany(input: $input, condition: $condition) {
    id
    name
    lowerName
    lowerNameKey
    displayCompanyName
    slug
    type
    logo {
      version
      __typename
    }
    domainWhitelist
    onboardingSections {
      companyInfo
      contactInfo
      companyPreferences
      immigrationPreferences
      paymentPreferences
      questions
      employeeInformation
      __typename
    }
    hasCompletedOnboardingQuestions
    completedOnboardingQuestionsBy
    isPartnerCompany
    isParent
    children {
      nextToken
      __typename
    }
    parent {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    parentID
    archived
    companyNumber
    nationalCount
    foreignNationals {
      nextToken
      __typename
    }
    assignedAttorneys {
      nextToken
      __typename
    }
    assignedParalegals {
      nextToken
      __typename
    }
    accountManagerID
    accountManager {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    assignedEmployers {
      nextToken
      __typename
    }
    assignedEmployerAdmins {
      nextToken
      __typename
    }
    invoicingContacts {
      nextToken
      __typename
    }
    primaryContacts {
      nextToken
      __typename
    }
    seniorContacts {
      nextToken
      __typename
    }
    signatoryContacts {
      nextToken
      __typename
    }
    data {
      id
      companyID
      preferredMailingAddress
      companyNameShowToFN
      companyCoversExpenseOfDependentPetitionsAndOrEADCards
      doingBusinessAs
      educationEvaluation
      employeesEmailMHAttorneysAndParalegalsDirectly
      fein
      fullTimeEmployeesInUS
      isH1BDependentEmloyer
      hasBeenWillfulViolator
      isHigherEd_20_USC_1001_a
      isHigherEdNonProfit_8_CFR_214_2_h_19_iii_B
      isHigherEdNonProfit_8_CFR_214_2_h_8_ii_F_2
      isNonProfitResearch_8_CFR_214_2_h_19_iii_C
      isNonProfitResearch_8_CFR_214_2_h_8_ii_F_3
      isQualifyingCapExempt_8_CFR_214_2_h_8_ii_F_4
      maintainsAWrittenImmigrationPolicy
      naicsCodeOfCompany
      partTimeEmployeesInUS
      paymentPreference
      permissionPowerAttorney
      permissionReleaseApprovalNotices
      permissionReleasePetitionsRFE
      permissionReleaseLCA
      permissionRelease9089
      phone
      placesEmployeesAtClientSitesForMoreThanACoupleOfDaysAtATime
      fax
      preferredShippingSpeedForDocuments
      shipOriginalApprovalNotices
      staffsEmployeesAtThirdPartyEndClientSites
      typeOfBusiness
      usesWageSurvey
      usesEVerify
      utilizePremiumProcessingService
      technologyReleaseLicenseRequirement
      yearCompanyWasFoundedInUS
      I9_audit_has_been_completed_in_past_18_months
      current_number_of_H1B_employees
      current_number_of_employees_on_L_visas
      other_visa_statuses_sponsored
      email_address_invoices_should_be_addressed_to
      name_invoices_should_be_addressed_to
      companyCoversExpenseOfDependentPetitions
      placesEmployeesAtClientSitesForMoreThan30DaysAtATime
      annualMeetingDate
      requiresMeetingReminder
      createdAt
      updatedAt
      __typename
    }
    processRequests {
      nextToken
      __typename
    }
    jobDescriptions {
      nextToken
      __typename
    }
    files {
      nextToken
      __typename
    }
    fileRequirements {
      type
      fileType
      fileCategory
      fileInstruction
      defaultStorage
      visibility
      assignedToID
      isAssignedToLegalAssistants
      expirationDateRequired
      issueDateRequired
      dueDateRequired
      isApproved
      isRequested
      hidden
      durationOfStatus
      __typename
    }
    cases {
      nextToken
      __typename
    }
    openCaseCount
    closedCaseCount
    completedCaseCount
    legalTeamIDs
    notes
    petitionerParagraph
    reportEntries {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    companyDataId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCompanyMutationVariables,
  APITypes.DeleteCompanyMutation
>;
export const createFirm = /* GraphQL */ `mutation CreateFirm(
  $input: CreateFirmInput!
  $condition: ModelFirmConditionInput
) {
  createFirm(input: $input, condition: $condition) {
    id
    name
    slug
    logo {
      version
      __typename
    }
    domainWhitelist
    address {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    mailingAddress {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    doingBusinessAs
    phone
    fax
    knowledgeCenterLinks {
      id
      text
      roles
      __typename
    }
    shortcuts {
      id
      text
      link
      roles
      __typename
    }
    holidays
    companyCount
    nationalCount
    preparedFormTemplates {
      id
      name
      processes
      archived
      updatedAt
      requiresAttorneyApproval
      requiresSponsorApproval
      requiresNationalApproval
      employersCanView
      nationalsCanView
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFirmMutationVariables,
  APITypes.CreateFirmMutation
>;
export const updateFirm = /* GraphQL */ `mutation UpdateFirm(
  $input: UpdateFirmInput!
  $condition: ModelFirmConditionInput
) {
  updateFirm(input: $input, condition: $condition) {
    id
    name
    slug
    logo {
      version
      __typename
    }
    domainWhitelist
    address {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    mailingAddress {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    doingBusinessAs
    phone
    fax
    knowledgeCenterLinks {
      id
      text
      roles
      __typename
    }
    shortcuts {
      id
      text
      link
      roles
      __typename
    }
    holidays
    companyCount
    nationalCount
    preparedFormTemplates {
      id
      name
      processes
      archived
      updatedAt
      requiresAttorneyApproval
      requiresSponsorApproval
      requiresNationalApproval
      employersCanView
      nationalsCanView
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFirmMutationVariables,
  APITypes.UpdateFirmMutation
>;
export const deleteFirm = /* GraphQL */ `mutation DeleteFirm(
  $input: DeleteFirmInput!
  $condition: ModelFirmConditionInput
) {
  deleteFirm(input: $input, condition: $condition) {
    id
    name
    slug
    logo {
      version
      __typename
    }
    domainWhitelist
    address {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    mailingAddress {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    doingBusinessAs
    phone
    fax
    knowledgeCenterLinks {
      id
      text
      roles
      __typename
    }
    shortcuts {
      id
      text
      link
      roles
      __typename
    }
    holidays
    companyCount
    nationalCount
    preparedFormTemplates {
      id
      name
      processes
      archived
      updatedAt
      requiresAttorneyApproval
      requiresSponsorApproval
      requiresNationalApproval
      employersCanView
      nationalsCanView
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFirmMutationVariables,
  APITypes.DeleteFirmMutation
>;
export const createCompanyData = /* GraphQL */ `mutation CreateCompanyData(
  $input: CreateCompanyDataInput!
  $condition: ModelCompanyDataConditionInput
) {
  createCompanyData(input: $input, condition: $condition) {
    id
    companyID
    addressPrimary {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    addressSecondary {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    allowsEmployeesToTelecommute {
      value
      followPrompt
      followValue
      followPromptSecond
      followValueSecond
      __typename
    }
    preferredMailingAddress
    companyNameShowToFN
    companyCoversExpenseOfDependentPetitionsAndOrEADCards
    doingBusinessAs
    educationEvaluation
    employeesEmailMHAttorneysAndParalegalsDirectly
    fein
    fullTimeEmployeesInUS
    grossRevenueForMostRecentFiscalYear {
      currency
      amount
      period
      __typename
    }
    isH1BDependentEmloyer
    hasBeenWillfulViolator
    employs50OrMore {
      value
      followPrompt
      followValue
      __typename
    }
    isHigherEd_20_USC_1001_a
    isHigherEdNonProfit_8_CFR_214_2_h_19_iii_B
    isHigherEdNonProfit_8_CFR_214_2_h_8_ii_F_2
    isNonProfitResearch_8_CFR_214_2_h_19_iii_C
    isNonProfitResearch_8_CFR_214_2_h_8_ii_F_3
    isQualifyingCapExempt_8_CFR_214_2_h_8_ii_F_4
    maintainsAWrittenImmigrationPolicy
    naicsCodeOfCompany
    netRevenueForMostRecentFiscalYear {
      currency
      amount
      period
      __typename
    }
    partTimeEmployeesInUS
    paymentPreference
    permissionPowerAttorney
    permissionReleaseApprovalNotices
    permissionReleasePetitionsRFE
    permissionReleaseLCA
    permissionRelease9089
    phone
    placesEmployeesAtClientSitesForMoreThanACoupleOfDaysAtATime
    preferenceForEmployeesToPayPartOfGreenCard {
      value
      reason
      __typename
    }
    preferenceForEmployeesToPayPartOfH1B {
      value
      reason
      __typename
    }
    fax
    preferredShippingSpeedForDocuments
    shipOriginalApprovalNotices
    shippingPreference {
      preference
      fedexAccount
      upsAccount
      __typename
    }
    staffsEmployeesAtThirdPartyEndClientSites
    typeOfBusiness
    usesWageSurvey
    usesApplicantTrackingSystem {
      value
      reason
      __typename
    }
    usesHRSSystem {
      value
      reason
      __typename
    }
    usesEVerify
    utilizePremiumProcessingService
    technologyReleaseLicenseRequirement
    yearCompanyWasFoundedInUS
    I9_audit_has_been_completed_in_past_18_months
    current_number_of_H1B_employees
    current_number_of_employees_on_L_visas
    other_visa_statuses_sponsored
    email_address_invoices_should_be_addressed_to
    name_invoices_should_be_addressed_to
    companyCoversExpenseOfDependentPetitions
    placesEmployeesAtClientSitesForMoreThan30DaysAtATime
    annualMeetingDate
    requiresMeetingReminder
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCompanyDataMutationVariables,
  APITypes.CreateCompanyDataMutation
>;
export const updateCompanyData = /* GraphQL */ `mutation UpdateCompanyData(
  $input: UpdateCompanyDataInput!
  $condition: ModelCompanyDataConditionInput
) {
  updateCompanyData(input: $input, condition: $condition) {
    id
    companyID
    addressPrimary {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    addressSecondary {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    allowsEmployeesToTelecommute {
      value
      followPrompt
      followValue
      followPromptSecond
      followValueSecond
      __typename
    }
    preferredMailingAddress
    companyNameShowToFN
    companyCoversExpenseOfDependentPetitionsAndOrEADCards
    doingBusinessAs
    educationEvaluation
    employeesEmailMHAttorneysAndParalegalsDirectly
    fein
    fullTimeEmployeesInUS
    grossRevenueForMostRecentFiscalYear {
      currency
      amount
      period
      __typename
    }
    isH1BDependentEmloyer
    hasBeenWillfulViolator
    employs50OrMore {
      value
      followPrompt
      followValue
      __typename
    }
    isHigherEd_20_USC_1001_a
    isHigherEdNonProfit_8_CFR_214_2_h_19_iii_B
    isHigherEdNonProfit_8_CFR_214_2_h_8_ii_F_2
    isNonProfitResearch_8_CFR_214_2_h_19_iii_C
    isNonProfitResearch_8_CFR_214_2_h_8_ii_F_3
    isQualifyingCapExempt_8_CFR_214_2_h_8_ii_F_4
    maintainsAWrittenImmigrationPolicy
    naicsCodeOfCompany
    netRevenueForMostRecentFiscalYear {
      currency
      amount
      period
      __typename
    }
    partTimeEmployeesInUS
    paymentPreference
    permissionPowerAttorney
    permissionReleaseApprovalNotices
    permissionReleasePetitionsRFE
    permissionReleaseLCA
    permissionRelease9089
    phone
    placesEmployeesAtClientSitesForMoreThanACoupleOfDaysAtATime
    preferenceForEmployeesToPayPartOfGreenCard {
      value
      reason
      __typename
    }
    preferenceForEmployeesToPayPartOfH1B {
      value
      reason
      __typename
    }
    fax
    preferredShippingSpeedForDocuments
    shipOriginalApprovalNotices
    shippingPreference {
      preference
      fedexAccount
      upsAccount
      __typename
    }
    staffsEmployeesAtThirdPartyEndClientSites
    typeOfBusiness
    usesWageSurvey
    usesApplicantTrackingSystem {
      value
      reason
      __typename
    }
    usesHRSSystem {
      value
      reason
      __typename
    }
    usesEVerify
    utilizePremiumProcessingService
    technologyReleaseLicenseRequirement
    yearCompanyWasFoundedInUS
    I9_audit_has_been_completed_in_past_18_months
    current_number_of_H1B_employees
    current_number_of_employees_on_L_visas
    other_visa_statuses_sponsored
    email_address_invoices_should_be_addressed_to
    name_invoices_should_be_addressed_to
    companyCoversExpenseOfDependentPetitions
    placesEmployeesAtClientSitesForMoreThan30DaysAtATime
    annualMeetingDate
    requiresMeetingReminder
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCompanyDataMutationVariables,
  APITypes.UpdateCompanyDataMutation
>;
export const deleteCompanyData = /* GraphQL */ `mutation DeleteCompanyData(
  $input: DeleteCompanyDataInput!
  $condition: ModelCompanyDataConditionInput
) {
  deleteCompanyData(input: $input, condition: $condition) {
    id
    companyID
    addressPrimary {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    addressSecondary {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    allowsEmployeesToTelecommute {
      value
      followPrompt
      followValue
      followPromptSecond
      followValueSecond
      __typename
    }
    preferredMailingAddress
    companyNameShowToFN
    companyCoversExpenseOfDependentPetitionsAndOrEADCards
    doingBusinessAs
    educationEvaluation
    employeesEmailMHAttorneysAndParalegalsDirectly
    fein
    fullTimeEmployeesInUS
    grossRevenueForMostRecentFiscalYear {
      currency
      amount
      period
      __typename
    }
    isH1BDependentEmloyer
    hasBeenWillfulViolator
    employs50OrMore {
      value
      followPrompt
      followValue
      __typename
    }
    isHigherEd_20_USC_1001_a
    isHigherEdNonProfit_8_CFR_214_2_h_19_iii_B
    isHigherEdNonProfit_8_CFR_214_2_h_8_ii_F_2
    isNonProfitResearch_8_CFR_214_2_h_19_iii_C
    isNonProfitResearch_8_CFR_214_2_h_8_ii_F_3
    isQualifyingCapExempt_8_CFR_214_2_h_8_ii_F_4
    maintainsAWrittenImmigrationPolicy
    naicsCodeOfCompany
    netRevenueForMostRecentFiscalYear {
      currency
      amount
      period
      __typename
    }
    partTimeEmployeesInUS
    paymentPreference
    permissionPowerAttorney
    permissionReleaseApprovalNotices
    permissionReleasePetitionsRFE
    permissionReleaseLCA
    permissionRelease9089
    phone
    placesEmployeesAtClientSitesForMoreThanACoupleOfDaysAtATime
    preferenceForEmployeesToPayPartOfGreenCard {
      value
      reason
      __typename
    }
    preferenceForEmployeesToPayPartOfH1B {
      value
      reason
      __typename
    }
    fax
    preferredShippingSpeedForDocuments
    shipOriginalApprovalNotices
    shippingPreference {
      preference
      fedexAccount
      upsAccount
      __typename
    }
    staffsEmployeesAtThirdPartyEndClientSites
    typeOfBusiness
    usesWageSurvey
    usesApplicantTrackingSystem {
      value
      reason
      __typename
    }
    usesHRSSystem {
      value
      reason
      __typename
    }
    usesEVerify
    utilizePremiumProcessingService
    technologyReleaseLicenseRequirement
    yearCompanyWasFoundedInUS
    I9_audit_has_been_completed_in_past_18_months
    current_number_of_H1B_employees
    current_number_of_employees_on_L_visas
    other_visa_statuses_sponsored
    email_address_invoices_should_be_addressed_to
    name_invoices_should_be_addressed_to
    companyCoversExpenseOfDependentPetitions
    placesEmployeesAtClientSitesForMoreThan30DaysAtATime
    annualMeetingDate
    requiresMeetingReminder
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCompanyDataMutationVariables,
  APITypes.DeleteCompanyDataMutation
>;
export const createJobDescription = /* GraphQL */ `mutation CreateJobDescription(
  $input: CreateJobDescriptionInput!
  $condition: ModelJobDescriptionConditionInput
) {
  createJobDescription(input: $input, condition: $condition) {
    companyID
    id
    archived
    type
    foreignNationalID
    title
    officialTitle
    degrees
    requiresBachelors
    requiresMasters
    requiresPhd
    dotNumber
    caseSocCode
    duties
    jobURL
    majors
    specialRequirements
    yearsGeneralExperience
    objectiveSkillSetsRequired
    offeredSalary
    certificationLicenses
    travelIsRequired
    travelPercentage
    travelDomestic
    travelInternational
    supervisesOthers
    supervisesOthersCount
    supervisesTitles
    supervisorTitle
    canWorkFromHome
    uploadedDescriptionID
    uploadedDescription {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateJobDescriptionMutationVariables,
  APITypes.CreateJobDescriptionMutation
>;
export const updateJobDescription = /* GraphQL */ `mutation UpdateJobDescription(
  $input: UpdateJobDescriptionInput!
  $condition: ModelJobDescriptionConditionInput
) {
  updateJobDescription(input: $input, condition: $condition) {
    companyID
    id
    archived
    type
    foreignNationalID
    title
    officialTitle
    degrees
    requiresBachelors
    requiresMasters
    requiresPhd
    dotNumber
    caseSocCode
    duties
    jobURL
    majors
    specialRequirements
    yearsGeneralExperience
    objectiveSkillSetsRequired
    offeredSalary
    certificationLicenses
    travelIsRequired
    travelPercentage
    travelDomestic
    travelInternational
    supervisesOthers
    supervisesOthersCount
    supervisesTitles
    supervisorTitle
    canWorkFromHome
    uploadedDescriptionID
    uploadedDescription {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateJobDescriptionMutationVariables,
  APITypes.UpdateJobDescriptionMutation
>;
export const deleteJobDescription = /* GraphQL */ `mutation DeleteJobDescription(
  $input: DeleteJobDescriptionInput!
  $condition: ModelJobDescriptionConditionInput
) {
  deleteJobDescription(input: $input, condition: $condition) {
    companyID
    id
    archived
    type
    foreignNationalID
    title
    officialTitle
    degrees
    requiresBachelors
    requiresMasters
    requiresPhd
    dotNumber
    caseSocCode
    duties
    jobURL
    majors
    specialRequirements
    yearsGeneralExperience
    objectiveSkillSetsRequired
    offeredSalary
    certificationLicenses
    travelIsRequired
    travelPercentage
    travelDomestic
    travelInternational
    supervisesOthers
    supervisesOthersCount
    supervisesTitles
    supervisorTitle
    canWorkFromHome
    uploadedDescriptionID
    uploadedDescription {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteJobDescriptionMutationVariables,
  APITypes.DeleteJobDescriptionMutation
>;
export const createProcessRequest = /* GraphQL */ `mutation CreateProcessRequest(
  $input: CreateProcessRequestInput!
  $condition: ModelProcessRequestConditionInput
) {
  createProcessRequest(input: $input, condition: $condition) {
    id
    assignedToID
    assignedToEmployerID
    assignedToTeamMemberID
    assignedToEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    assignedToTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    caseNotes {
      nextToken
      __typename
    }
    companyID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    files {
      nextToken
      __typename
    }
    individualSponsored
    initiatorID
    initiator {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    jobDescriptionID
    jobDescription {
      companyID
      id
      archived
      type
      foreignNationalID
      title
      officialTitle
      degrees
      requiresBachelors
      requiresMasters
      requiresPhd
      dotNumber
      caseSocCode
      duties
      jobURL
      majors
      specialRequirements
      yearsGeneralExperience
      objectiveSkillSetsRequired
      offeredSalary
      certificationLicenses
      travelIsRequired
      travelPercentage
      travelDomestic
      travelInternational
      supervisesOthers
      supervisesOthersCount
      supervisesTitles
      supervisorTitle
      canWorkFromHome
      uploadedDescriptionID
      createdAt
      updatedAt
      __typename
    }
    requesterID
    requester {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    requestDate
    approvalDate
    archivedDate
    cancelDate
    foreignNationalID
    foreignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    employeeData {
      firstname
      lastname
      middlename
      email
      employeeId
      tempID
      spouse
      dependents
      __typename
    }
    employmentData {
      premiumProcessing
      startDate
      notes
      __typename
    }
    needsEmployerRevision
    resume {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    resumeID
    requestedProcess
    requestedProcessSubCategory
    requestedProcessAdditionalProcessing
    globalRequestedProcessSubCategory
    globalProcessCountryCode
    globalProcessDuration
    globalVisaType
    vendorID
    vendor {
      id
      name
      type
      location
      email
      lowerName
      updatedAt
      createdAt
      __typename
    }
    slug
    state
    lowerNationalName
    lowerCompanyName
    lowerProcessType
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProcessRequestMutationVariables,
  APITypes.CreateProcessRequestMutation
>;
export const updateProcessRequest = /* GraphQL */ `mutation UpdateProcessRequest(
  $input: UpdateProcessRequestInput!
  $condition: ModelProcessRequestConditionInput
) {
  updateProcessRequest(input: $input, condition: $condition) {
    id
    assignedToID
    assignedToEmployerID
    assignedToTeamMemberID
    assignedToEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    assignedToTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    caseNotes {
      nextToken
      __typename
    }
    companyID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    files {
      nextToken
      __typename
    }
    individualSponsored
    initiatorID
    initiator {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    jobDescriptionID
    jobDescription {
      companyID
      id
      archived
      type
      foreignNationalID
      title
      officialTitle
      degrees
      requiresBachelors
      requiresMasters
      requiresPhd
      dotNumber
      caseSocCode
      duties
      jobURL
      majors
      specialRequirements
      yearsGeneralExperience
      objectiveSkillSetsRequired
      offeredSalary
      certificationLicenses
      travelIsRequired
      travelPercentage
      travelDomestic
      travelInternational
      supervisesOthers
      supervisesOthersCount
      supervisesTitles
      supervisorTitle
      canWorkFromHome
      uploadedDescriptionID
      createdAt
      updatedAt
      __typename
    }
    requesterID
    requester {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    requestDate
    approvalDate
    archivedDate
    cancelDate
    foreignNationalID
    foreignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    employeeData {
      firstname
      lastname
      middlename
      email
      employeeId
      tempID
      spouse
      dependents
      __typename
    }
    employmentData {
      premiumProcessing
      startDate
      notes
      __typename
    }
    needsEmployerRevision
    resume {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    resumeID
    requestedProcess
    requestedProcessSubCategory
    requestedProcessAdditionalProcessing
    globalRequestedProcessSubCategory
    globalProcessCountryCode
    globalProcessDuration
    globalVisaType
    vendorID
    vendor {
      id
      name
      type
      location
      email
      lowerName
      updatedAt
      createdAt
      __typename
    }
    slug
    state
    lowerNationalName
    lowerCompanyName
    lowerProcessType
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProcessRequestMutationVariables,
  APITypes.UpdateProcessRequestMutation
>;
export const deleteProcessRequest = /* GraphQL */ `mutation DeleteProcessRequest(
  $input: DeleteProcessRequestInput!
  $condition: ModelProcessRequestConditionInput
) {
  deleteProcessRequest(input: $input, condition: $condition) {
    id
    assignedToID
    assignedToEmployerID
    assignedToTeamMemberID
    assignedToEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    assignedToTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    caseNotes {
      nextToken
      __typename
    }
    companyID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    files {
      nextToken
      __typename
    }
    individualSponsored
    initiatorID
    initiator {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    jobDescriptionID
    jobDescription {
      companyID
      id
      archived
      type
      foreignNationalID
      title
      officialTitle
      degrees
      requiresBachelors
      requiresMasters
      requiresPhd
      dotNumber
      caseSocCode
      duties
      jobURL
      majors
      specialRequirements
      yearsGeneralExperience
      objectiveSkillSetsRequired
      offeredSalary
      certificationLicenses
      travelIsRequired
      travelPercentage
      travelDomestic
      travelInternational
      supervisesOthers
      supervisesOthersCount
      supervisesTitles
      supervisorTitle
      canWorkFromHome
      uploadedDescriptionID
      createdAt
      updatedAt
      __typename
    }
    requesterID
    requester {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    requestDate
    approvalDate
    archivedDate
    cancelDate
    foreignNationalID
    foreignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    employeeData {
      firstname
      lastname
      middlename
      email
      employeeId
      tempID
      spouse
      dependents
      __typename
    }
    employmentData {
      premiumProcessing
      startDate
      notes
      __typename
    }
    needsEmployerRevision
    resume {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    resumeID
    requestedProcess
    requestedProcessSubCategory
    requestedProcessAdditionalProcessing
    globalRequestedProcessSubCategory
    globalProcessCountryCode
    globalProcessDuration
    globalVisaType
    vendorID
    vendor {
      id
      name
      type
      location
      email
      lowerName
      updatedAt
      createdAt
      __typename
    }
    slug
    state
    lowerNationalName
    lowerCompanyName
    lowerProcessType
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProcessRequestMutationVariables,
  APITypes.DeleteProcessRequestMutation
>;
export const createCaseNote = /* GraphQL */ `mutation CreateCaseNote(
  $input: CreateCaseNoteInput!
  $condition: ModelCaseNoteConditionInput
) {
  createCaseNote(input: $input, condition: $condition) {
    id
    createdAt
    postDate
    authorID
    authorEmployerID
    authorTeamMemberID
    authorEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    authorTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    isPinned
    note
    caseID
    processRequestID
    companyID
    userGroup
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCaseNoteMutationVariables,
  APITypes.CreateCaseNoteMutation
>;
export const updateCaseNote = /* GraphQL */ `mutation UpdateCaseNote(
  $input: UpdateCaseNoteInput!
  $condition: ModelCaseNoteConditionInput
) {
  updateCaseNote(input: $input, condition: $condition) {
    id
    createdAt
    postDate
    authorID
    authorEmployerID
    authorTeamMemberID
    authorEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    authorTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    isPinned
    note
    caseID
    processRequestID
    companyID
    userGroup
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCaseNoteMutationVariables,
  APITypes.UpdateCaseNoteMutation
>;
export const deleteCaseNote = /* GraphQL */ `mutation DeleteCaseNote(
  $input: DeleteCaseNoteInput!
  $condition: ModelCaseNoteConditionInput
) {
  deleteCaseNote(input: $input, condition: $condition) {
    id
    createdAt
    postDate
    authorID
    authorEmployerID
    authorTeamMemberID
    authorEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    authorTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    isPinned
    note
    caseID
    processRequestID
    companyID
    userGroup
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCaseNoteMutationVariables,
  APITypes.DeleteCaseNoteMutation
>;
export const createCase = /* GraphQL */ `mutation CreateCase(
  $input: CreateCaseInput!
  $condition: ModelCaseConditionInput
) {
  createCase(input: $input, condition: $condition) {
    id
    caseNumber
    slug
    attorneyID
    attorney {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    caseManagerID
    caseManager {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    complianceListID
    complianceList {
      id
      caseID
      educationEvaluationNeeded
      stemExtEligible
      capGap
      wageIssues
      createdAt
      updatedAt
      __typename
    }
    PERMFilingDataID
    PERMFilingData {
      id
      caseID
      PERMFirstPossibleFilingDate
      PERMLastPossibleFilingDate
      applicantsReceived
      createdAt
      updatedAt
      __typename
    }
    caseNotes {
      nextToken
      __typename
    }
    pinnedCaseNoteID
    contributorIds
    contributors {
      nextToken
      __typename
    }
    sponsoringEmployerID
    sponsoringEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    sponsoringNationalID
    sponsoringNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    foreignNationalID
    foreignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    welcomeLetterAcknowledged
    welcomeLetterAcknowledgementDate
    welcomeLetterAcknowledgedBy
    welcomeLetterText
    nationalVisaExpiration
    relativeAdmins
    startDate
    closeDate
    closeReason
    completeDate
    sourceID
    source {
      id
      assignedToID
      assignedToEmployerID
      assignedToTeamMemberID
      companyID
      individualSponsored
      initiatorID
      jobDescriptionID
      requesterID
      requestDate
      approvalDate
      archivedDate
      cancelDate
      foreignNationalID
      needsEmployerRevision
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      slug
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      createdAt
      updatedAt
      __typename
    }
    state
    tasks {
      nextToken
      __typename
    }
    lowerNationalName
    lowerCompanyName
    lowerProcessType
    fileRequirements {
      type
      fileType
      fileCategory
      fileInstruction
      defaultStorage
      visibility
      assignedToID
      isAssignedToLegalAssistants
      expirationDateRequired
      issueDateRequired
      dueDateRequired
      isApproved
      isRequested
      hidden
      durationOfStatus
      __typename
    }
    currentPhase
    phaseRequirements {
      phase
      milestones
      __typename
    }
    completedMilestones {
      completionDate
      completedByID
      milestone
      receiptNumber
      __typename
    }
    files {
      nextToken
      __typename
    }
    preparedForms {
      nextToken
      __typename
    }
    prevailingWageCaseNumber
    USCISReceiptNumber
    USCISReceiptDetails {
      nextToken
      __typename
    }
    AOSReceiptNotice
    I485JReceiptNotice
    SelectionNoticeNo
    ETACaseNumber
    shipmentTracking {
      id
      item
      date
      trackingNumber
      provider
      __typename
    }
    isShipmentTrackingElectronically
    companyID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    individualSponsored
    jobDescriptionID
    jobDescription {
      companyID
      id
      archived
      type
      foreignNationalID
      title
      officialTitle
      degrees
      requiresBachelors
      requiresMasters
      requiresPhd
      dotNumber
      caseSocCode
      duties
      jobURL
      majors
      specialRequirements
      yearsGeneralExperience
      objectiveSkillSetsRequired
      offeredSalary
      certificationLicenses
      travelIsRequired
      travelPercentage
      travelDomestic
      travelInternational
      supervisesOthers
      supervisesOthersCount
      supervisesTitles
      supervisorTitle
      canWorkFromHome
      uploadedDescriptionID
      createdAt
      updatedAt
      __typename
    }
    employeeData {
      firstname
      lastname
      middlename
      email
      employeeId
      tempID
      spouse
      dependents
      __typename
    }
    employmentData {
      premiumProcessing
      startDate
      notes
      __typename
    }
    resumeID
    resume {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    requestedProcess
    requestedProcessSubCategory
    requestedProcessAdditionalProcessing
    globalRequestedProcessSubCategory
    globalProcessCountryCode
    globalProcessDuration
    globalVisaType
    vendorID
    additionalFieldID
    additionalFields {
      id
      caseID
      fields
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCaseMutationVariables,
  APITypes.CreateCaseMutation
>;
export const updateCase = /* GraphQL */ `mutation UpdateCase(
  $input: UpdateCaseInput!
  $condition: ModelCaseConditionInput
) {
  updateCase(input: $input, condition: $condition) {
    id
    caseNumber
    slug
    attorneyID
    attorney {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    caseManagerID
    caseManager {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    complianceListID
    complianceList {
      id
      caseID
      educationEvaluationNeeded
      stemExtEligible
      capGap
      wageIssues
      createdAt
      updatedAt
      __typename
    }
    PERMFilingDataID
    PERMFilingData {
      id
      caseID
      PERMFirstPossibleFilingDate
      PERMLastPossibleFilingDate
      applicantsReceived
      createdAt
      updatedAt
      __typename
    }
    caseNotes {
      nextToken
      __typename
    }
    pinnedCaseNoteID
    contributorIds
    contributors {
      nextToken
      __typename
    }
    sponsoringEmployerID
    sponsoringEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    sponsoringNationalID
    sponsoringNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    foreignNationalID
    foreignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    welcomeLetterAcknowledged
    welcomeLetterAcknowledgementDate
    welcomeLetterAcknowledgedBy
    welcomeLetterText
    nationalVisaExpiration
    relativeAdmins
    startDate
    closeDate
    closeReason
    completeDate
    sourceID
    source {
      id
      assignedToID
      assignedToEmployerID
      assignedToTeamMemberID
      companyID
      individualSponsored
      initiatorID
      jobDescriptionID
      requesterID
      requestDate
      approvalDate
      archivedDate
      cancelDate
      foreignNationalID
      needsEmployerRevision
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      slug
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      createdAt
      updatedAt
      __typename
    }
    state
    tasks {
      nextToken
      __typename
    }
    lowerNationalName
    lowerCompanyName
    lowerProcessType
    fileRequirements {
      type
      fileType
      fileCategory
      fileInstruction
      defaultStorage
      visibility
      assignedToID
      isAssignedToLegalAssistants
      expirationDateRequired
      issueDateRequired
      dueDateRequired
      isApproved
      isRequested
      hidden
      durationOfStatus
      __typename
    }
    currentPhase
    phaseRequirements {
      phase
      milestones
      __typename
    }
    completedMilestones {
      completionDate
      completedByID
      milestone
      receiptNumber
      __typename
    }
    files {
      nextToken
      __typename
    }
    preparedForms {
      nextToken
      __typename
    }
    prevailingWageCaseNumber
    USCISReceiptNumber
    USCISReceiptDetails {
      nextToken
      __typename
    }
    AOSReceiptNotice
    I485JReceiptNotice
    SelectionNoticeNo
    ETACaseNumber
    shipmentTracking {
      id
      item
      date
      trackingNumber
      provider
      __typename
    }
    isShipmentTrackingElectronically
    companyID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    individualSponsored
    jobDescriptionID
    jobDescription {
      companyID
      id
      archived
      type
      foreignNationalID
      title
      officialTitle
      degrees
      requiresBachelors
      requiresMasters
      requiresPhd
      dotNumber
      caseSocCode
      duties
      jobURL
      majors
      specialRequirements
      yearsGeneralExperience
      objectiveSkillSetsRequired
      offeredSalary
      certificationLicenses
      travelIsRequired
      travelPercentage
      travelDomestic
      travelInternational
      supervisesOthers
      supervisesOthersCount
      supervisesTitles
      supervisorTitle
      canWorkFromHome
      uploadedDescriptionID
      createdAt
      updatedAt
      __typename
    }
    employeeData {
      firstname
      lastname
      middlename
      email
      employeeId
      tempID
      spouse
      dependents
      __typename
    }
    employmentData {
      premiumProcessing
      startDate
      notes
      __typename
    }
    resumeID
    resume {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    requestedProcess
    requestedProcessSubCategory
    requestedProcessAdditionalProcessing
    globalRequestedProcessSubCategory
    globalProcessCountryCode
    globalProcessDuration
    globalVisaType
    vendorID
    additionalFieldID
    additionalFields {
      id
      caseID
      fields
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCaseMutationVariables,
  APITypes.UpdateCaseMutation
>;
export const deleteCase = /* GraphQL */ `mutation DeleteCase(
  $input: DeleteCaseInput!
  $condition: ModelCaseConditionInput
) {
  deleteCase(input: $input, condition: $condition) {
    id
    caseNumber
    slug
    attorneyID
    attorney {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    caseManagerID
    caseManager {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    complianceListID
    complianceList {
      id
      caseID
      educationEvaluationNeeded
      stemExtEligible
      capGap
      wageIssues
      createdAt
      updatedAt
      __typename
    }
    PERMFilingDataID
    PERMFilingData {
      id
      caseID
      PERMFirstPossibleFilingDate
      PERMLastPossibleFilingDate
      applicantsReceived
      createdAt
      updatedAt
      __typename
    }
    caseNotes {
      nextToken
      __typename
    }
    pinnedCaseNoteID
    contributorIds
    contributors {
      nextToken
      __typename
    }
    sponsoringEmployerID
    sponsoringEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    sponsoringNationalID
    sponsoringNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    foreignNationalID
    foreignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    welcomeLetterAcknowledged
    welcomeLetterAcknowledgementDate
    welcomeLetterAcknowledgedBy
    welcomeLetterText
    nationalVisaExpiration
    relativeAdmins
    startDate
    closeDate
    closeReason
    completeDate
    sourceID
    source {
      id
      assignedToID
      assignedToEmployerID
      assignedToTeamMemberID
      companyID
      individualSponsored
      initiatorID
      jobDescriptionID
      requesterID
      requestDate
      approvalDate
      archivedDate
      cancelDate
      foreignNationalID
      needsEmployerRevision
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      slug
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      createdAt
      updatedAt
      __typename
    }
    state
    tasks {
      nextToken
      __typename
    }
    lowerNationalName
    lowerCompanyName
    lowerProcessType
    fileRequirements {
      type
      fileType
      fileCategory
      fileInstruction
      defaultStorage
      visibility
      assignedToID
      isAssignedToLegalAssistants
      expirationDateRequired
      issueDateRequired
      dueDateRequired
      isApproved
      isRequested
      hidden
      durationOfStatus
      __typename
    }
    currentPhase
    phaseRequirements {
      phase
      milestones
      __typename
    }
    completedMilestones {
      completionDate
      completedByID
      milestone
      receiptNumber
      __typename
    }
    files {
      nextToken
      __typename
    }
    preparedForms {
      nextToken
      __typename
    }
    prevailingWageCaseNumber
    USCISReceiptNumber
    USCISReceiptDetails {
      nextToken
      __typename
    }
    AOSReceiptNotice
    I485JReceiptNotice
    SelectionNoticeNo
    ETACaseNumber
    shipmentTracking {
      id
      item
      date
      trackingNumber
      provider
      __typename
    }
    isShipmentTrackingElectronically
    companyID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    individualSponsored
    jobDescriptionID
    jobDescription {
      companyID
      id
      archived
      type
      foreignNationalID
      title
      officialTitle
      degrees
      requiresBachelors
      requiresMasters
      requiresPhd
      dotNumber
      caseSocCode
      duties
      jobURL
      majors
      specialRequirements
      yearsGeneralExperience
      objectiveSkillSetsRequired
      offeredSalary
      certificationLicenses
      travelIsRequired
      travelPercentage
      travelDomestic
      travelInternational
      supervisesOthers
      supervisesOthersCount
      supervisesTitles
      supervisorTitle
      canWorkFromHome
      uploadedDescriptionID
      createdAt
      updatedAt
      __typename
    }
    employeeData {
      firstname
      lastname
      middlename
      email
      employeeId
      tempID
      spouse
      dependents
      __typename
    }
    employmentData {
      premiumProcessing
      startDate
      notes
      __typename
    }
    resumeID
    resume {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    requestedProcess
    requestedProcessSubCategory
    requestedProcessAdditionalProcessing
    globalRequestedProcessSubCategory
    globalProcessCountryCode
    globalProcessDuration
    globalVisaType
    vendorID
    additionalFieldID
    additionalFields {
      id
      caseID
      fields
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCaseMutationVariables,
  APITypes.DeleteCaseMutation
>;
export const createUSCISReceiptDetails = /* GraphQL */ `mutation CreateUSCISReceiptDetails(
  $input: CreateUSCISReceiptDetailsInput!
  $condition: ModelUSCISReceiptDetailsConditionInput
) {
  createUSCISReceiptDetails(input: $input, condition: $condition) {
    id
    caseID
    receiptType
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    receiptNumber
    formType
    submittedDate
    modifiedDate
    currentCaseStatusText
    currentCaseStatusDesc
    histCaseStatus {
      date
      completedText
      __typename
    }
    message
    isActive
    isLatest
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUSCISReceiptDetailsMutationVariables,
  APITypes.CreateUSCISReceiptDetailsMutation
>;
export const updateUSCISReceiptDetails = /* GraphQL */ `mutation UpdateUSCISReceiptDetails(
  $input: UpdateUSCISReceiptDetailsInput!
  $condition: ModelUSCISReceiptDetailsConditionInput
) {
  updateUSCISReceiptDetails(input: $input, condition: $condition) {
    id
    caseID
    receiptType
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    receiptNumber
    formType
    submittedDate
    modifiedDate
    currentCaseStatusText
    currentCaseStatusDesc
    histCaseStatus {
      date
      completedText
      __typename
    }
    message
    isActive
    isLatest
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUSCISReceiptDetailsMutationVariables,
  APITypes.UpdateUSCISReceiptDetailsMutation
>;
export const deleteUSCISReceiptDetails = /* GraphQL */ `mutation DeleteUSCISReceiptDetails(
  $input: DeleteUSCISReceiptDetailsInput!
  $condition: ModelUSCISReceiptDetailsConditionInput
) {
  deleteUSCISReceiptDetails(input: $input, condition: $condition) {
    id
    caseID
    receiptType
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    receiptNumber
    formType
    submittedDate
    modifiedDate
    currentCaseStatusText
    currentCaseStatusDesc
    histCaseStatus {
      date
      completedText
      __typename
    }
    message
    isActive
    isLatest
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUSCISReceiptDetailsMutationVariables,
  APITypes.DeleteUSCISReceiptDetailsMutation
>;
export const createCaseComplianceList = /* GraphQL */ `mutation CreateCaseComplianceList(
  $input: CreateCaseComplianceListInput!
  $condition: ModelCaseComplianceListConditionInput
) {
  createCaseComplianceList(input: $input, condition: $condition) {
    id
    caseID
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    educationEvaluationNeeded
    stemExtEligible
    capGap
    wageIssues
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCaseComplianceListMutationVariables,
  APITypes.CreateCaseComplianceListMutation
>;
export const updateCaseComplianceList = /* GraphQL */ `mutation UpdateCaseComplianceList(
  $input: UpdateCaseComplianceListInput!
  $condition: ModelCaseComplianceListConditionInput
) {
  updateCaseComplianceList(input: $input, condition: $condition) {
    id
    caseID
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    educationEvaluationNeeded
    stemExtEligible
    capGap
    wageIssues
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCaseComplianceListMutationVariables,
  APITypes.UpdateCaseComplianceListMutation
>;
export const deleteCaseComplianceList = /* GraphQL */ `mutation DeleteCaseComplianceList(
  $input: DeleteCaseComplianceListInput!
  $condition: ModelCaseComplianceListConditionInput
) {
  deleteCaseComplianceList(input: $input, condition: $condition) {
    id
    caseID
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    educationEvaluationNeeded
    stemExtEligible
    capGap
    wageIssues
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCaseComplianceListMutationVariables,
  APITypes.DeleteCaseComplianceListMutation
>;
export const createPERMFilingData = /* GraphQL */ `mutation CreatePERMFilingData(
  $input: CreatePERMFilingDataInput!
  $condition: ModelPERMFilingDataConditionInput
) {
  createPERMFilingData(input: $input, condition: $condition) {
    id
    caseID
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    PERMFirstPossibleFilingDate
    PERMLastPossibleFilingDate
    applicantsReceived
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePERMFilingDataMutationVariables,
  APITypes.CreatePERMFilingDataMutation
>;
export const updatePERMFilingData = /* GraphQL */ `mutation UpdatePERMFilingData(
  $input: UpdatePERMFilingDataInput!
  $condition: ModelPERMFilingDataConditionInput
) {
  updatePERMFilingData(input: $input, condition: $condition) {
    id
    caseID
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    PERMFirstPossibleFilingDate
    PERMLastPossibleFilingDate
    applicantsReceived
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePERMFilingDataMutationVariables,
  APITypes.UpdatePERMFilingDataMutation
>;
export const deletePERMFilingData = /* GraphQL */ `mutation DeletePERMFilingData(
  $input: DeletePERMFilingDataInput!
  $condition: ModelPERMFilingDataConditionInput
) {
  deletePERMFilingData(input: $input, condition: $condition) {
    id
    caseID
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    PERMFirstPossibleFilingDate
    PERMLastPossibleFilingDate
    applicantsReceived
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePERMFilingDataMutationVariables,
  APITypes.DeletePERMFilingDataMutation
>;
export const createCaseContributor = /* GraphQL */ `mutation CreateCaseContributor(
  $input: CreateCaseContributorInput!
  $condition: ModelCaseContributorConditionInput
) {
  createCaseContributor(input: $input, condition: $condition) {
    id
    caseID
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    contributorID
    contributorEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    contributorForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    contributorTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    foreignNationalID
    foreignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    state
    type
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCaseContributorMutationVariables,
  APITypes.CreateCaseContributorMutation
>;
export const updateCaseContributor = /* GraphQL */ `mutation UpdateCaseContributor(
  $input: UpdateCaseContributorInput!
  $condition: ModelCaseContributorConditionInput
) {
  updateCaseContributor(input: $input, condition: $condition) {
    id
    caseID
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    contributorID
    contributorEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    contributorForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    contributorTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    foreignNationalID
    foreignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    state
    type
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCaseContributorMutationVariables,
  APITypes.UpdateCaseContributorMutation
>;
export const deleteCaseContributor = /* GraphQL */ `mutation DeleteCaseContributor(
  $input: DeleteCaseContributorInput!
  $condition: ModelCaseContributorConditionInput
) {
  deleteCaseContributor(input: $input, condition: $condition) {
    id
    caseID
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    contributorID
    contributorEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    contributorForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    contributorTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    foreignNationalID
    foreignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    state
    type
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCaseContributorMutationVariables,
  APITypes.DeleteCaseContributorMutation
>;
export const createTask = /* GraphQL */ `mutation CreateTask(
  $input: CreateTaskInput!
  $condition: ModelTaskConditionInput
) {
  createTask(input: $input, condition: $condition) {
    id
    action
    isKeyDate
    keyDateAlternateAction
    isPaymentStatus
    paymentStatusAlternateAction
    assignedToID
    isAssignedToLegalAssistants
    assignedToEmployerID
    assignedToForeignNationalID
    assignedToTeamMemberID
    assignedToEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    assignedToForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    assignedToTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    caseID
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    caseState
    category
    companyID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    comments {
      nextToken
      __typename
    }
    completeDate
    deadline
    deadlineIsManuallySet
    deleteDate
    deleteReason
    dependencies {
      nextToken
      __typename
    }
    description
    duration
    foreignNationalID
    foreignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    groupsCanRead
    isCustom
    isManuallyUnlocked
    prerequisite {
      id
      action
      isKeyDate
      keyDateAlternateAction
      isPaymentStatus
      paymentStatusAlternateAction
      assignedToID
      isAssignedToLegalAssistants
      assignedToEmployerID
      assignedToForeignNationalID
      assignedToTeamMemberID
      caseID
      caseState
      category
      companyID
      completeDate
      deadline
      deadlineIsManuallySet
      deleteDate
      deleteReason
      description
      duration
      foreignNationalID
      groupsCanRead
      isCustom
      isManuallyUnlocked
      prerequisiteID
      startDate
      state
      templateID
      assigneeLowerName
      attorneyLowerFirstName
      attorneyLowerName
      paralegalLowerName
      paralegalLowerFirstName
      companyLowerName
      nationalLowerName
      orderIndex
      defaultAssignee
      createdAt
      updatedAt
      foreignNationalTasksId
      employerTasksId
      __typename
    }
    prerequisiteID
    startDate
    state
    templateID
    assigneeLowerName
    attorneyLowerFirstName
    attorneyLowerName
    paralegalLowerName
    paralegalLowerFirstName
    companyLowerName
    nationalLowerName
    orderIndex
    defaultAssignee
    createdAt
    updatedAt
    foreignNationalTasksId
    employerTasksId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTaskMutationVariables,
  APITypes.CreateTaskMutation
>;
export const updateTask = /* GraphQL */ `mutation UpdateTask(
  $input: UpdateTaskInput!
  $condition: ModelTaskConditionInput
) {
  updateTask(input: $input, condition: $condition) {
    id
    action
    isKeyDate
    keyDateAlternateAction
    isPaymentStatus
    paymentStatusAlternateAction
    assignedToID
    isAssignedToLegalAssistants
    assignedToEmployerID
    assignedToForeignNationalID
    assignedToTeamMemberID
    assignedToEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    assignedToForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    assignedToTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    caseID
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    caseState
    category
    companyID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    comments {
      nextToken
      __typename
    }
    completeDate
    deadline
    deadlineIsManuallySet
    deleteDate
    deleteReason
    dependencies {
      nextToken
      __typename
    }
    description
    duration
    foreignNationalID
    foreignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    groupsCanRead
    isCustom
    isManuallyUnlocked
    prerequisite {
      id
      action
      isKeyDate
      keyDateAlternateAction
      isPaymentStatus
      paymentStatusAlternateAction
      assignedToID
      isAssignedToLegalAssistants
      assignedToEmployerID
      assignedToForeignNationalID
      assignedToTeamMemberID
      caseID
      caseState
      category
      companyID
      completeDate
      deadline
      deadlineIsManuallySet
      deleteDate
      deleteReason
      description
      duration
      foreignNationalID
      groupsCanRead
      isCustom
      isManuallyUnlocked
      prerequisiteID
      startDate
      state
      templateID
      assigneeLowerName
      attorneyLowerFirstName
      attorneyLowerName
      paralegalLowerName
      paralegalLowerFirstName
      companyLowerName
      nationalLowerName
      orderIndex
      defaultAssignee
      createdAt
      updatedAt
      foreignNationalTasksId
      employerTasksId
      __typename
    }
    prerequisiteID
    startDate
    state
    templateID
    assigneeLowerName
    attorneyLowerFirstName
    attorneyLowerName
    paralegalLowerName
    paralegalLowerFirstName
    companyLowerName
    nationalLowerName
    orderIndex
    defaultAssignee
    createdAt
    updatedAt
    foreignNationalTasksId
    employerTasksId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTaskMutationVariables,
  APITypes.UpdateTaskMutation
>;
export const deleteTask = /* GraphQL */ `mutation DeleteTask(
  $input: DeleteTaskInput!
  $condition: ModelTaskConditionInput
) {
  deleteTask(input: $input, condition: $condition) {
    id
    action
    isKeyDate
    keyDateAlternateAction
    isPaymentStatus
    paymentStatusAlternateAction
    assignedToID
    isAssignedToLegalAssistants
    assignedToEmployerID
    assignedToForeignNationalID
    assignedToTeamMemberID
    assignedToEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    assignedToForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    assignedToTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    caseID
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    caseState
    category
    companyID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    comments {
      nextToken
      __typename
    }
    completeDate
    deadline
    deadlineIsManuallySet
    deleteDate
    deleteReason
    dependencies {
      nextToken
      __typename
    }
    description
    duration
    foreignNationalID
    foreignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    groupsCanRead
    isCustom
    isManuallyUnlocked
    prerequisite {
      id
      action
      isKeyDate
      keyDateAlternateAction
      isPaymentStatus
      paymentStatusAlternateAction
      assignedToID
      isAssignedToLegalAssistants
      assignedToEmployerID
      assignedToForeignNationalID
      assignedToTeamMemberID
      caseID
      caseState
      category
      companyID
      completeDate
      deadline
      deadlineIsManuallySet
      deleteDate
      deleteReason
      description
      duration
      foreignNationalID
      groupsCanRead
      isCustom
      isManuallyUnlocked
      prerequisiteID
      startDate
      state
      templateID
      assigneeLowerName
      attorneyLowerFirstName
      attorneyLowerName
      paralegalLowerName
      paralegalLowerFirstName
      companyLowerName
      nationalLowerName
      orderIndex
      defaultAssignee
      createdAt
      updatedAt
      foreignNationalTasksId
      employerTasksId
      __typename
    }
    prerequisiteID
    startDate
    state
    templateID
    assigneeLowerName
    attorneyLowerFirstName
    attorneyLowerName
    paralegalLowerName
    paralegalLowerFirstName
    companyLowerName
    nationalLowerName
    orderIndex
    defaultAssignee
    createdAt
    updatedAt
    foreignNationalTasksId
    employerTasksId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTaskMutationVariables,
  APITypes.DeleteTaskMutation
>;
export const createTaskTemplate = /* GraphQL */ `mutation CreateTaskTemplate(
  $input: CreateTaskTemplateInput!
  $condition: ModelTaskTemplateConditionInput
) {
  createTaskTemplate(input: $input, condition: $condition) {
    id
    defaultAssignee
    duration
    groupsCanRead
    lockedByDefault
    action
    isKeyDate
    keyDateAlternateAction
    isPaymentStatus
    description
    paymentStatusAlternateAction
    prerequisiteID
    process
    category
    hidden
    isManuallyUnlocked
    durationFromStartDate
    orderIndex
    startDate
    deadline
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTaskTemplateMutationVariables,
  APITypes.CreateTaskTemplateMutation
>;
export const updateTaskTemplate = /* GraphQL */ `mutation UpdateTaskTemplate(
  $input: UpdateTaskTemplateInput!
  $condition: ModelTaskTemplateConditionInput
) {
  updateTaskTemplate(input: $input, condition: $condition) {
    id
    defaultAssignee
    duration
    groupsCanRead
    lockedByDefault
    action
    isKeyDate
    keyDateAlternateAction
    isPaymentStatus
    description
    paymentStatusAlternateAction
    prerequisiteID
    process
    category
    hidden
    isManuallyUnlocked
    durationFromStartDate
    orderIndex
    startDate
    deadline
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTaskTemplateMutationVariables,
  APITypes.UpdateTaskTemplateMutation
>;
export const deleteTaskTemplate = /* GraphQL */ `mutation DeleteTaskTemplate(
  $input: DeleteTaskTemplateInput!
  $condition: ModelTaskTemplateConditionInput
) {
  deleteTaskTemplate(input: $input, condition: $condition) {
    id
    defaultAssignee
    duration
    groupsCanRead
    lockedByDefault
    action
    isKeyDate
    keyDateAlternateAction
    isPaymentStatus
    description
    paymentStatusAlternateAction
    prerequisiteID
    process
    category
    hidden
    isManuallyUnlocked
    durationFromStartDate
    orderIndex
    startDate
    deadline
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTaskTemplateMutationVariables,
  APITypes.DeleteTaskTemplateMutation
>;
export const createComment = /* GraphQL */ `mutation CreateComment(
  $input: CreateCommentInput!
  $condition: ModelCommentConditionInput
) {
  createComment(input: $input, condition: $condition) {
    createdAt
    authorID
    authorEmployerID
    authorForeignNationalID
    authorTeamMemberID
    authorEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    authorForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    authorTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    note
    sourceID
    id
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCommentMutationVariables,
  APITypes.CreateCommentMutation
>;
export const updateComment = /* GraphQL */ `mutation UpdateComment(
  $input: UpdateCommentInput!
  $condition: ModelCommentConditionInput
) {
  updateComment(input: $input, condition: $condition) {
    createdAt
    authorID
    authorEmployerID
    authorForeignNationalID
    authorTeamMemberID
    authorEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    authorForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    authorTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    note
    sourceID
    id
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCommentMutationVariables,
  APITypes.UpdateCommentMutation
>;
export const deleteComment = /* GraphQL */ `mutation DeleteComment(
  $input: DeleteCommentInput!
  $condition: ModelCommentConditionInput
) {
  deleteComment(input: $input, condition: $condition) {
    createdAt
    authorID
    authorEmployerID
    authorForeignNationalID
    authorTeamMemberID
    authorEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    authorForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    authorTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    note
    sourceID
    id
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCommentMutationVariables,
  APITypes.DeleteCommentMutation
>;
export const createFileData = /* GraphQL */ `mutation CreateFileData(
  $input: CreateFileDataInput!
  $condition: ModelFileDataConditionInput
) {
  createFileData(input: $input, condition: $condition) {
    id
    expirationDate
    durationOfStatus
    fileName
    original {
      bucket
      region
      key
      level
      identityId
      __typename
    }
    fileType
    fileRequirement
    fileCategory
    contentType
    issueDate
    dueDate
    isFlattened
    processRequestID
    companyID
    ownerNationalID
    sourceID
    uploadDate
    uploaderID
    uploaderEmployerID
    uploaderForeignNationalID
    uploaderTeamMemberID
    uploaderForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    uploaderTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    uploaderEmployer {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    cases {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFileDataMutationVariables,
  APITypes.CreateFileDataMutation
>;
export const updateFileData = /* GraphQL */ `mutation UpdateFileData(
  $input: UpdateFileDataInput!
  $condition: ModelFileDataConditionInput
) {
  updateFileData(input: $input, condition: $condition) {
    id
    expirationDate
    durationOfStatus
    fileName
    original {
      bucket
      region
      key
      level
      identityId
      __typename
    }
    fileType
    fileRequirement
    fileCategory
    contentType
    issueDate
    dueDate
    isFlattened
    processRequestID
    companyID
    ownerNationalID
    sourceID
    uploadDate
    uploaderID
    uploaderEmployerID
    uploaderForeignNationalID
    uploaderTeamMemberID
    uploaderForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    uploaderTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    uploaderEmployer {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    cases {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFileDataMutationVariables,
  APITypes.UpdateFileDataMutation
>;
export const deleteFileData = /* GraphQL */ `mutation DeleteFileData(
  $input: DeleteFileDataInput!
  $condition: ModelFileDataConditionInput
) {
  deleteFileData(input: $input, condition: $condition) {
    id
    expirationDate
    durationOfStatus
    fileName
    original {
      bucket
      region
      key
      level
      identityId
      __typename
    }
    fileType
    fileRequirement
    fileCategory
    contentType
    issueDate
    dueDate
    isFlattened
    processRequestID
    companyID
    ownerNationalID
    sourceID
    uploadDate
    uploaderID
    uploaderEmployerID
    uploaderForeignNationalID
    uploaderTeamMemberID
    uploaderForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    uploaderTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    uploaderEmployer {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    cases {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFileDataMutationVariables,
  APITypes.DeleteFileDataMutation
>;
export const createCaseRfgp = /* GraphQL */ `mutation CreateCaseRfgp(
  $input: CreateCaseRfgpInput!
  $condition: ModelCaseRfgpConditionInput
) {
  createCaseRfgp(input: $input, condition: $condition) {
    id
    caseID
    items {
      itemType
      id
      __typename
    }
    status
    jobID
    fileID
    file {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    usedFileIDs
    skipped {
      itemType
      id
      reason
      __typename
    }
    errorMessage
    generatedAt
    generatedByID
    generatedBy {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    updatedByID
    updatedBy {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCaseRfgpMutationVariables,
  APITypes.CreateCaseRfgpMutation
>;
export const updateCaseRfgp = /* GraphQL */ `mutation UpdateCaseRfgp(
  $input: UpdateCaseRfgpInput!
  $condition: ModelCaseRfgpConditionInput
) {
  updateCaseRfgp(input: $input, condition: $condition) {
    id
    caseID
    items {
      itemType
      id
      __typename
    }
    status
    jobID
    fileID
    file {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    usedFileIDs
    skipped {
      itemType
      id
      reason
      __typename
    }
    errorMessage
    generatedAt
    generatedByID
    generatedBy {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    updatedByID
    updatedBy {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCaseRfgpMutationVariables,
  APITypes.UpdateCaseRfgpMutation
>;
export const deleteCaseRfgp = /* GraphQL */ `mutation DeleteCaseRfgp(
  $input: DeleteCaseRfgpInput!
  $condition: ModelCaseRfgpConditionInput
) {
  deleteCaseRfgp(input: $input, condition: $condition) {
    id
    caseID
    items {
      itemType
      id
      __typename
    }
    status
    jobID
    fileID
    file {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    usedFileIDs
    skipped {
      itemType
      id
      reason
      __typename
    }
    errorMessage
    generatedAt
    generatedByID
    generatedBy {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    updatedByID
    updatedBy {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCaseRfgpMutationVariables,
  APITypes.DeleteCaseRfgpMutation
>;
export const createCaseFile = /* GraphQL */ `mutation CreateCaseFile(
  $input: CreateCaseFileInput!
  $condition: ModelCaseFileConditionInput
) {
  createCaseFile(input: $input, condition: $condition) {
    id
    fileID
    caseID
    file {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCaseFileMutationVariables,
  APITypes.CreateCaseFileMutation
>;
export const updateCaseFile = /* GraphQL */ `mutation UpdateCaseFile(
  $input: UpdateCaseFileInput!
  $condition: ModelCaseFileConditionInput
) {
  updateCaseFile(input: $input, condition: $condition) {
    id
    fileID
    caseID
    file {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCaseFileMutationVariables,
  APITypes.UpdateCaseFileMutation
>;
export const deleteCaseFile = /* GraphQL */ `mutation DeleteCaseFile(
  $input: DeleteCaseFileInput!
  $condition: ModelCaseFileConditionInput
) {
  deleteCaseFile(input: $input, condition: $condition) {
    id
    fileID
    caseID
    file {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCaseFileMutationVariables,
  APITypes.DeleteCaseFileMutation
>;
export const createActivity = /* GraphQL */ `mutation CreateActivity(
  $input: CreateActivityInput!
  $condition: ModelActivityConditionInput
) {
  createActivity(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    activityType
    ipAddress
    fieldName
    updatedValue
    actorID
    actorEmployerID
    actorForeignNationalID
    actorTeamMemberID
    actorType
    actorEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    actorForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    actorTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    directTargetID
    directTargetCaseID
    directTargetCompanyID
    directTargetEmployerID
    directTargetFileDataID
    directTargetForeignNationalID
    directTargetProcessRequestID
    directTargetTaskID
    directTargetTeamMemberID
    directTargetReportID
    targetString
    targetCase {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    targetCompany {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    targetEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    targetFileData {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    targetForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    targetProcessRequest {
      id
      assignedToID
      assignedToEmployerID
      assignedToTeamMemberID
      companyID
      individualSponsored
      initiatorID
      jobDescriptionID
      requesterID
      requestDate
      approvalDate
      archivedDate
      cancelDate
      foreignNationalID
      needsEmployerRevision
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      slug
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      createdAt
      updatedAt
      __typename
    }
    targetTask {
      id
      action
      isKeyDate
      keyDateAlternateAction
      isPaymentStatus
      paymentStatusAlternateAction
      assignedToID
      isAssignedToLegalAssistants
      assignedToEmployerID
      assignedToForeignNationalID
      assignedToTeamMemberID
      caseID
      caseState
      category
      companyID
      completeDate
      deadline
      deadlineIsManuallySet
      deleteDate
      deleteReason
      description
      duration
      foreignNationalID
      groupsCanRead
      isCustom
      isManuallyUnlocked
      prerequisiteID
      startDate
      state
      templateID
      assigneeLowerName
      attorneyLowerFirstName
      attorneyLowerName
      paralegalLowerName
      paralegalLowerFirstName
      companyLowerName
      nationalLowerName
      orderIndex
      defaultAssignee
      createdAt
      updatedAt
      foreignNationalTasksId
      employerTasksId
      __typename
    }
    targetTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    targetReport {
      id
      templateID
      companyIds
      accessibleIds
      editableIds
      viewAccess
      editAccess
      type
      name
      status
      numberOfFilters
      numberOfColumns
      fromTemplate
      totalCountCycle
      completedCountCycle
      isCurrent
      createdAt
      updatedAt
      __typename
    }
    indirectTargetID
    indirectTargetCaseID
    indirectTargetCompanyID
    indirectTargetEmployerID
    indirectTargetForeignNationalID
    indirectTargetProcessRequestID
    indirectTargetTeamMemberID
    indirectTargetReportID
    indirectTargetString
    indirectTargetCase {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    indirectTargetCompany {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    indirectTargetEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    indirectTargetForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    indirectTargetProcessRequest {
      id
      assignedToID
      assignedToEmployerID
      assignedToTeamMemberID
      companyID
      individualSponsored
      initiatorID
      jobDescriptionID
      requesterID
      requestDate
      approvalDate
      archivedDate
      cancelDate
      foreignNationalID
      needsEmployerRevision
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      slug
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      createdAt
      updatedAt
      __typename
    }
    indirectTargetTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    indirectTargetReport {
      id
      templateID
      companyIds
      accessibleIds
      editableIds
      viewAccess
      editAccess
      type
      name
      status
      numberOfFilters
      numberOfColumns
      fromTemplate
      totalCountCycle
      completedCountCycle
      isCurrent
      createdAt
      updatedAt
      __typename
    }
    ownerID
    ownerCaseID
    ownerCompanyID
    ownerEmployerID
    ownerFileDataID
    ownerForeignNationalID
    ownerProcessRequestID
    ownerTeamMemberID
    ownerReportID
    ownerCase {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    ownerCompany {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    ownerEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    ownerFileData {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    ownerForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    ownerProcessRequest {
      id
      assignedToID
      assignedToEmployerID
      assignedToTeamMemberID
      companyID
      individualSponsored
      initiatorID
      jobDescriptionID
      requesterID
      requestDate
      approvalDate
      archivedDate
      cancelDate
      foreignNationalID
      needsEmployerRevision
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      slug
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      createdAt
      updatedAt
      __typename
    }
    ownerTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    ownerReport {
      id
      templateID
      companyIds
      accessibleIds
      editableIds
      viewAccess
      editAccess
      type
      name
      status
      numberOfFilters
      numberOfColumns
      fromTemplate
      totalCountCycle
      completedCountCycle
      isCurrent
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateActivityMutationVariables,
  APITypes.CreateActivityMutation
>;
export const updateActivity = /* GraphQL */ `mutation UpdateActivity(
  $input: UpdateActivityInput!
  $condition: ModelActivityConditionInput
) {
  updateActivity(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    activityType
    ipAddress
    fieldName
    updatedValue
    actorID
    actorEmployerID
    actorForeignNationalID
    actorTeamMemberID
    actorType
    actorEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    actorForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    actorTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    directTargetID
    directTargetCaseID
    directTargetCompanyID
    directTargetEmployerID
    directTargetFileDataID
    directTargetForeignNationalID
    directTargetProcessRequestID
    directTargetTaskID
    directTargetTeamMemberID
    directTargetReportID
    targetString
    targetCase {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    targetCompany {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    targetEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    targetFileData {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    targetForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    targetProcessRequest {
      id
      assignedToID
      assignedToEmployerID
      assignedToTeamMemberID
      companyID
      individualSponsored
      initiatorID
      jobDescriptionID
      requesterID
      requestDate
      approvalDate
      archivedDate
      cancelDate
      foreignNationalID
      needsEmployerRevision
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      slug
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      createdAt
      updatedAt
      __typename
    }
    targetTask {
      id
      action
      isKeyDate
      keyDateAlternateAction
      isPaymentStatus
      paymentStatusAlternateAction
      assignedToID
      isAssignedToLegalAssistants
      assignedToEmployerID
      assignedToForeignNationalID
      assignedToTeamMemberID
      caseID
      caseState
      category
      companyID
      completeDate
      deadline
      deadlineIsManuallySet
      deleteDate
      deleteReason
      description
      duration
      foreignNationalID
      groupsCanRead
      isCustom
      isManuallyUnlocked
      prerequisiteID
      startDate
      state
      templateID
      assigneeLowerName
      attorneyLowerFirstName
      attorneyLowerName
      paralegalLowerName
      paralegalLowerFirstName
      companyLowerName
      nationalLowerName
      orderIndex
      defaultAssignee
      createdAt
      updatedAt
      foreignNationalTasksId
      employerTasksId
      __typename
    }
    targetTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    targetReport {
      id
      templateID
      companyIds
      accessibleIds
      editableIds
      viewAccess
      editAccess
      type
      name
      status
      numberOfFilters
      numberOfColumns
      fromTemplate
      totalCountCycle
      completedCountCycle
      isCurrent
      createdAt
      updatedAt
      __typename
    }
    indirectTargetID
    indirectTargetCaseID
    indirectTargetCompanyID
    indirectTargetEmployerID
    indirectTargetForeignNationalID
    indirectTargetProcessRequestID
    indirectTargetTeamMemberID
    indirectTargetReportID
    indirectTargetString
    indirectTargetCase {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    indirectTargetCompany {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    indirectTargetEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    indirectTargetForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    indirectTargetProcessRequest {
      id
      assignedToID
      assignedToEmployerID
      assignedToTeamMemberID
      companyID
      individualSponsored
      initiatorID
      jobDescriptionID
      requesterID
      requestDate
      approvalDate
      archivedDate
      cancelDate
      foreignNationalID
      needsEmployerRevision
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      slug
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      createdAt
      updatedAt
      __typename
    }
    indirectTargetTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    indirectTargetReport {
      id
      templateID
      companyIds
      accessibleIds
      editableIds
      viewAccess
      editAccess
      type
      name
      status
      numberOfFilters
      numberOfColumns
      fromTemplate
      totalCountCycle
      completedCountCycle
      isCurrent
      createdAt
      updatedAt
      __typename
    }
    ownerID
    ownerCaseID
    ownerCompanyID
    ownerEmployerID
    ownerFileDataID
    ownerForeignNationalID
    ownerProcessRequestID
    ownerTeamMemberID
    ownerReportID
    ownerCase {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    ownerCompany {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    ownerEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    ownerFileData {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    ownerForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    ownerProcessRequest {
      id
      assignedToID
      assignedToEmployerID
      assignedToTeamMemberID
      companyID
      individualSponsored
      initiatorID
      jobDescriptionID
      requesterID
      requestDate
      approvalDate
      archivedDate
      cancelDate
      foreignNationalID
      needsEmployerRevision
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      slug
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      createdAt
      updatedAt
      __typename
    }
    ownerTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    ownerReport {
      id
      templateID
      companyIds
      accessibleIds
      editableIds
      viewAccess
      editAccess
      type
      name
      status
      numberOfFilters
      numberOfColumns
      fromTemplate
      totalCountCycle
      completedCountCycle
      isCurrent
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateActivityMutationVariables,
  APITypes.UpdateActivityMutation
>;
export const deleteActivity = /* GraphQL */ `mutation DeleteActivity(
  $input: DeleteActivityInput!
  $condition: ModelActivityConditionInput
) {
  deleteActivity(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    activityType
    ipAddress
    fieldName
    updatedValue
    actorID
    actorEmployerID
    actorForeignNationalID
    actorTeamMemberID
    actorType
    actorEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    actorForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    actorTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    directTargetID
    directTargetCaseID
    directTargetCompanyID
    directTargetEmployerID
    directTargetFileDataID
    directTargetForeignNationalID
    directTargetProcessRequestID
    directTargetTaskID
    directTargetTeamMemberID
    directTargetReportID
    targetString
    targetCase {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    targetCompany {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    targetEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    targetFileData {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    targetForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    targetProcessRequest {
      id
      assignedToID
      assignedToEmployerID
      assignedToTeamMemberID
      companyID
      individualSponsored
      initiatorID
      jobDescriptionID
      requesterID
      requestDate
      approvalDate
      archivedDate
      cancelDate
      foreignNationalID
      needsEmployerRevision
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      slug
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      createdAt
      updatedAt
      __typename
    }
    targetTask {
      id
      action
      isKeyDate
      keyDateAlternateAction
      isPaymentStatus
      paymentStatusAlternateAction
      assignedToID
      isAssignedToLegalAssistants
      assignedToEmployerID
      assignedToForeignNationalID
      assignedToTeamMemberID
      caseID
      caseState
      category
      companyID
      completeDate
      deadline
      deadlineIsManuallySet
      deleteDate
      deleteReason
      description
      duration
      foreignNationalID
      groupsCanRead
      isCustom
      isManuallyUnlocked
      prerequisiteID
      startDate
      state
      templateID
      assigneeLowerName
      attorneyLowerFirstName
      attorneyLowerName
      paralegalLowerName
      paralegalLowerFirstName
      companyLowerName
      nationalLowerName
      orderIndex
      defaultAssignee
      createdAt
      updatedAt
      foreignNationalTasksId
      employerTasksId
      __typename
    }
    targetTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    targetReport {
      id
      templateID
      companyIds
      accessibleIds
      editableIds
      viewAccess
      editAccess
      type
      name
      status
      numberOfFilters
      numberOfColumns
      fromTemplate
      totalCountCycle
      completedCountCycle
      isCurrent
      createdAt
      updatedAt
      __typename
    }
    indirectTargetID
    indirectTargetCaseID
    indirectTargetCompanyID
    indirectTargetEmployerID
    indirectTargetForeignNationalID
    indirectTargetProcessRequestID
    indirectTargetTeamMemberID
    indirectTargetReportID
    indirectTargetString
    indirectTargetCase {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    indirectTargetCompany {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    indirectTargetEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    indirectTargetForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    indirectTargetProcessRequest {
      id
      assignedToID
      assignedToEmployerID
      assignedToTeamMemberID
      companyID
      individualSponsored
      initiatorID
      jobDescriptionID
      requesterID
      requestDate
      approvalDate
      archivedDate
      cancelDate
      foreignNationalID
      needsEmployerRevision
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      slug
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      createdAt
      updatedAt
      __typename
    }
    indirectTargetTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    indirectTargetReport {
      id
      templateID
      companyIds
      accessibleIds
      editableIds
      viewAccess
      editAccess
      type
      name
      status
      numberOfFilters
      numberOfColumns
      fromTemplate
      totalCountCycle
      completedCountCycle
      isCurrent
      createdAt
      updatedAt
      __typename
    }
    ownerID
    ownerCaseID
    ownerCompanyID
    ownerEmployerID
    ownerFileDataID
    ownerForeignNationalID
    ownerProcessRequestID
    ownerTeamMemberID
    ownerReportID
    ownerCase {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    ownerCompany {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    ownerEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    ownerFileData {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    ownerForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    ownerProcessRequest {
      id
      assignedToID
      assignedToEmployerID
      assignedToTeamMemberID
      companyID
      individualSponsored
      initiatorID
      jobDescriptionID
      requesterID
      requestDate
      approvalDate
      archivedDate
      cancelDate
      foreignNationalID
      needsEmployerRevision
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      slug
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      createdAt
      updatedAt
      __typename
    }
    ownerTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    ownerReport {
      id
      templateID
      companyIds
      accessibleIds
      editableIds
      viewAccess
      editAccess
      type
      name
      status
      numberOfFilters
      numberOfColumns
      fromTemplate
      totalCountCycle
      completedCountCycle
      isCurrent
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteActivityMutationVariables,
  APITypes.DeleteActivityMutation
>;
export const createNotification = /* GraphQL */ `mutation CreateNotification(
  $input: CreateNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  createNotification(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    personID
    activityID
    activity {
      id
      createdAt
      updatedAt
      activityType
      ipAddress
      fieldName
      updatedValue
      actorID
      actorEmployerID
      actorForeignNationalID
      actorTeamMemberID
      actorType
      directTargetID
      directTargetCaseID
      directTargetCompanyID
      directTargetEmployerID
      directTargetFileDataID
      directTargetForeignNationalID
      directTargetProcessRequestID
      directTargetTaskID
      directTargetTeamMemberID
      directTargetReportID
      targetString
      indirectTargetID
      indirectTargetCaseID
      indirectTargetCompanyID
      indirectTargetEmployerID
      indirectTargetForeignNationalID
      indirectTargetProcessRequestID
      indirectTargetTeamMemberID
      indirectTargetReportID
      indirectTargetString
      ownerID
      ownerCaseID
      ownerCompanyID
      ownerEmployerID
      ownerFileDataID
      ownerForeignNationalID
      ownerProcessRequestID
      ownerTeamMemberID
      ownerReportID
      __typename
    }
    read
    personNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    personEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    personTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateNotificationMutationVariables,
  APITypes.CreateNotificationMutation
>;
export const updateNotification = /* GraphQL */ `mutation UpdateNotification(
  $input: UpdateNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  updateNotification(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    personID
    activityID
    activity {
      id
      createdAt
      updatedAt
      activityType
      ipAddress
      fieldName
      updatedValue
      actorID
      actorEmployerID
      actorForeignNationalID
      actorTeamMemberID
      actorType
      directTargetID
      directTargetCaseID
      directTargetCompanyID
      directTargetEmployerID
      directTargetFileDataID
      directTargetForeignNationalID
      directTargetProcessRequestID
      directTargetTaskID
      directTargetTeamMemberID
      directTargetReportID
      targetString
      indirectTargetID
      indirectTargetCaseID
      indirectTargetCompanyID
      indirectTargetEmployerID
      indirectTargetForeignNationalID
      indirectTargetProcessRequestID
      indirectTargetTeamMemberID
      indirectTargetReportID
      indirectTargetString
      ownerID
      ownerCaseID
      ownerCompanyID
      ownerEmployerID
      ownerFileDataID
      ownerForeignNationalID
      ownerProcessRequestID
      ownerTeamMemberID
      ownerReportID
      __typename
    }
    read
    personNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    personEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    personTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateNotificationMutationVariables,
  APITypes.UpdateNotificationMutation
>;
export const deleteNotification = /* GraphQL */ `mutation DeleteNotification(
  $input: DeleteNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  deleteNotification(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    personID
    activityID
    activity {
      id
      createdAt
      updatedAt
      activityType
      ipAddress
      fieldName
      updatedValue
      actorID
      actorEmployerID
      actorForeignNationalID
      actorTeamMemberID
      actorType
      directTargetID
      directTargetCaseID
      directTargetCompanyID
      directTargetEmployerID
      directTargetFileDataID
      directTargetForeignNationalID
      directTargetProcessRequestID
      directTargetTaskID
      directTargetTeamMemberID
      directTargetReportID
      targetString
      indirectTargetID
      indirectTargetCaseID
      indirectTargetCompanyID
      indirectTargetEmployerID
      indirectTargetForeignNationalID
      indirectTargetProcessRequestID
      indirectTargetTeamMemberID
      indirectTargetReportID
      indirectTargetString
      ownerID
      ownerCaseID
      ownerCompanyID
      ownerEmployerID
      ownerFileDataID
      ownerForeignNationalID
      ownerProcessRequestID
      ownerTeamMemberID
      ownerReportID
      __typename
    }
    read
    personNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    personEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    personTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteNotificationMutationVariables,
  APITypes.DeleteNotificationMutation
>;
export const createAdditionalFields = /* GraphQL */ `mutation CreateAdditionalFields(
  $input: CreateAdditionalFieldsInput!
  $condition: ModelAdditionalFieldsConditionInput
) {
  createAdditionalFields(input: $input, condition: $condition) {
    id
    caseID
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    fields
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAdditionalFieldsMutationVariables,
  APITypes.CreateAdditionalFieldsMutation
>;
export const updateAdditionalFields = /* GraphQL */ `mutation UpdateAdditionalFields(
  $input: UpdateAdditionalFieldsInput!
  $condition: ModelAdditionalFieldsConditionInput
) {
  updateAdditionalFields(input: $input, condition: $condition) {
    id
    caseID
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    fields
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAdditionalFieldsMutationVariables,
  APITypes.UpdateAdditionalFieldsMutation
>;
export const deleteAdditionalFields = /* GraphQL */ `mutation DeleteAdditionalFields(
  $input: DeleteAdditionalFieldsInput!
  $condition: ModelAdditionalFieldsConditionInput
) {
  deleteAdditionalFields(input: $input, condition: $condition) {
    id
    caseID
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    fields
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAdditionalFieldsMutationVariables,
  APITypes.DeleteAdditionalFieldsMutation
>;
export const createCustomTemplate = /* GraphQL */ `mutation CreateCustomTemplate(
  $input: CreateCustomTemplateInput!
  $condition: ModelCustomTemplateConditionInput
) {
  createCustomTemplate(input: $input, condition: $condition) {
    id
    teamMemberId
    teamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    employerID
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    reports {
      nextToken
      __typename
    }
    templateReports {
      nextToken
      __typename
    }
    accessibleIds
    editableIds
    name
    selectedFields
    includeFN
    individualFNCase
    includeCases
    numberOfFilters
    numberOfColumns
    type
    category
    isDeleted
    viewAccess
    editAccess
    accessibleCompanyIds
    companyIds
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCustomTemplateMutationVariables,
  APITypes.CreateCustomTemplateMutation
>;
export const updateCustomTemplate = /* GraphQL */ `mutation UpdateCustomTemplate(
  $input: UpdateCustomTemplateInput!
  $condition: ModelCustomTemplateConditionInput
) {
  updateCustomTemplate(input: $input, condition: $condition) {
    id
    teamMemberId
    teamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    employerID
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    reports {
      nextToken
      __typename
    }
    templateReports {
      nextToken
      __typename
    }
    accessibleIds
    editableIds
    name
    selectedFields
    includeFN
    individualFNCase
    includeCases
    numberOfFilters
    numberOfColumns
    type
    category
    isDeleted
    viewAccess
    editAccess
    accessibleCompanyIds
    companyIds
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCustomTemplateMutationVariables,
  APITypes.UpdateCustomTemplateMutation
>;
export const deleteCustomTemplate = /* GraphQL */ `mutation DeleteCustomTemplate(
  $input: DeleteCustomTemplateInput!
  $condition: ModelCustomTemplateConditionInput
) {
  deleteCustomTemplate(input: $input, condition: $condition) {
    id
    teamMemberId
    teamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    employerID
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    reports {
      nextToken
      __typename
    }
    templateReports {
      nextToken
      __typename
    }
    accessibleIds
    editableIds
    name
    selectedFields
    includeFN
    individualFNCase
    includeCases
    numberOfFilters
    numberOfColumns
    type
    category
    isDeleted
    viewAccess
    editAccess
    accessibleCompanyIds
    companyIds
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCustomTemplateMutationVariables,
  APITypes.DeleteCustomTemplateMutation
>;
export const createReport = /* GraphQL */ `mutation CreateReport(
  $input: CreateReportInput!
  $condition: ModelReportConditionInput
) {
  createReport(input: $input, condition: $condition) {
    id
    templateID
    template {
      id
      teamMemberId
      employerID
      accessibleIds
      editableIds
      name
      selectedFields
      includeFN
      individualFNCase
      includeCases
      numberOfFilters
      numberOfColumns
      type
      category
      isDeleted
      viewAccess
      editAccess
      accessibleCompanyIds
      companyIds
      createdAt
      updatedAt
      __typename
    }
    customTemplate {
      id
      teamMemberId
      employerID
      accessibleIds
      editableIds
      name
      selectedFields
      includeFN
      individualFNCase
      includeCases
      numberOfFilters
      numberOfColumns
      type
      category
      isDeleted
      viewAccess
      editAccess
      accessibleCompanyIds
      companyIds
      createdAt
      updatedAt
      __typename
    }
    reportEntries {
      nextToken
      __typename
    }
    companyIds
    accessibleIds
    editableIds
    viewAccess
    editAccess
    type
    name
    status
    numberOfFilters
    numberOfColumns
    fromTemplate
    totalCountCycle
    completedCountCycle
    isCurrent
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateReportMutationVariables,
  APITypes.CreateReportMutation
>;
export const updateReport = /* GraphQL */ `mutation UpdateReport(
  $input: UpdateReportInput!
  $condition: ModelReportConditionInput
) {
  updateReport(input: $input, condition: $condition) {
    id
    templateID
    template {
      id
      teamMemberId
      employerID
      accessibleIds
      editableIds
      name
      selectedFields
      includeFN
      individualFNCase
      includeCases
      numberOfFilters
      numberOfColumns
      type
      category
      isDeleted
      viewAccess
      editAccess
      accessibleCompanyIds
      companyIds
      createdAt
      updatedAt
      __typename
    }
    customTemplate {
      id
      teamMemberId
      employerID
      accessibleIds
      editableIds
      name
      selectedFields
      includeFN
      individualFNCase
      includeCases
      numberOfFilters
      numberOfColumns
      type
      category
      isDeleted
      viewAccess
      editAccess
      accessibleCompanyIds
      companyIds
      createdAt
      updatedAt
      __typename
    }
    reportEntries {
      nextToken
      __typename
    }
    companyIds
    accessibleIds
    editableIds
    viewAccess
    editAccess
    type
    name
    status
    numberOfFilters
    numberOfColumns
    fromTemplate
    totalCountCycle
    completedCountCycle
    isCurrent
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateReportMutationVariables,
  APITypes.UpdateReportMutation
>;
export const deleteReport = /* GraphQL */ `mutation DeleteReport(
  $input: DeleteReportInput!
  $condition: ModelReportConditionInput
) {
  deleteReport(input: $input, condition: $condition) {
    id
    templateID
    template {
      id
      teamMemberId
      employerID
      accessibleIds
      editableIds
      name
      selectedFields
      includeFN
      individualFNCase
      includeCases
      numberOfFilters
      numberOfColumns
      type
      category
      isDeleted
      viewAccess
      editAccess
      accessibleCompanyIds
      companyIds
      createdAt
      updatedAt
      __typename
    }
    customTemplate {
      id
      teamMemberId
      employerID
      accessibleIds
      editableIds
      name
      selectedFields
      includeFN
      individualFNCase
      includeCases
      numberOfFilters
      numberOfColumns
      type
      category
      isDeleted
      viewAccess
      editAccess
      accessibleCompanyIds
      companyIds
      createdAt
      updatedAt
      __typename
    }
    reportEntries {
      nextToken
      __typename
    }
    companyIds
    accessibleIds
    editableIds
    viewAccess
    editAccess
    type
    name
    status
    numberOfFilters
    numberOfColumns
    fromTemplate
    totalCountCycle
    completedCountCycle
    isCurrent
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteReportMutationVariables,
  APITypes.DeleteReportMutation
>;
export const createReportEntries = /* GraphQL */ `mutation CreateReportEntries(
  $input: CreateReportEntriesInput!
  $condition: ModelReportEntriesConditionInput
) {
  createReportEntries(input: $input, condition: $condition) {
    id
    reportID
    report {
      id
      templateID
      companyIds
      accessibleIds
      editableIds
      viewAccess
      editAccess
      type
      name
      status
      numberOfFilters
      numberOfColumns
      fromTemplate
      totalCountCycle
      completedCountCycle
      isCurrent
      createdAt
      updatedAt
      __typename
    }
    companyID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    foreignNationalID
    foreignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    fullname
    firstname
    lastname
    middlename
    archived
    email
    personalEmail
    birthDate
    numberOfDependents
    numberOfFamilyContacts
    displayCompanyName
    companyLegalName
    companyFullName
    sponsoringCompanyFullName
    companyDbaName
    immigrationCurrentStatus
    immigrationStatusExpiration
    birthCountryCode
    citizenshipCountry
    chargeabilityCountry
    passportExpirationDate
    nivMaxout
    visaExpDate
    hasApprovedI140
    petitionerI140
    employmentBasedCategory
    priorityDate
    fnJobTitle
    socCode
    caseSocCode
    fnSalary
    startDate
    fnWorkLocation
    addressPrimary
    addressSecondary
    usResidentialAddress
    lastProcessType
    currentProcessType
    lowerProcessType
    lastPhaseCompleted
    currentPhase
    capType
    eadExpDate
    I797ApprovalExpDate
    I94ExpDate
    I94DS
    greenCardExpDate
    prevailingWageExpDate
    citizenshipEligibilityDate
    rfeDueDate
    dolAuditDueDate
    pwdExpDate
    firstEntryUS
    taxTrackingF1J1
    agreementExpDate
    agreementEffectiveDate
    mswsowExpDate
    permDueDate
    lotterySelectionDueDate
    advancedParoleExpDate
    reEntryPermitExpDate
    certifiedLcaExpDate
    title
    notes
    DS2019ExpDate
    isRelative
    relativeIds
    nextPhase
    requestedProcessSubCategory
    fnNameSlug
    caseSlug
    companyNameSlug
    employerNameSlug
    inviteStatus
    passportNumber
    phoneNumber
    personalPhone
    faxNumber
    passportGender
    preferredMailingAddress
    onboardingSections
    lastEntryUS
    employeeId
    caseNumber
    requestedProcess
    attorneyID
    caseAttorney
    sponsoringEmployerID
    sponsoringNationalID
    caseSponsor
    caseSponsorId
    caseManagerID
    caseManager
    contributorIds
    caseContributors
    caseStartDate
    caseOpenDate
    caseSalary
    state
    workLocation
    keyFilingDates
    lcaFiled
    capGap
    visaAdditionalProcessing
    stemExtEligible
    educationEvaluationNeeded
    wageIssues
    selection
    caseNature
    registrationCompleted
    receiptNumber
    currentCaseStatusText
    modifiedDate
    incompleteUscisReceiptNumber
    caseStatusHistory
    companyAttorneys
    companyAttorneyIds
    companyParalegals
    companyParalegalIds
    companyTotalCases
    companyTotalOpenCases
    companyTotalClosedCases
    companyTotalCompletedCases
    companyNationalCount
    fullTimeEmployeesInUS
    partTimeEmployeesInUS
    companyActiveNationalCount
    grossRevenueForMostRecentFiscalYear
    netRevenueForMostRecentFiscalYear
    naicsCodeOfCompany
    typeOfBusiness
    fein
    yearCompanyWasFoundedInUS
    aosFilingEligible
    requiresMeetingReminder
    isParent
    isPartnerCompany
    companyWhitelistedDomains
    companyContactLabel
    annualMeetingDate
    emCompanyNames
    emCompanyNameSlugs
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateReportEntriesMutationVariables,
  APITypes.CreateReportEntriesMutation
>;
export const updateReportEntries = /* GraphQL */ `mutation UpdateReportEntries(
  $input: UpdateReportEntriesInput!
  $condition: ModelReportEntriesConditionInput
) {
  updateReportEntries(input: $input, condition: $condition) {
    id
    reportID
    report {
      id
      templateID
      companyIds
      accessibleIds
      editableIds
      viewAccess
      editAccess
      type
      name
      status
      numberOfFilters
      numberOfColumns
      fromTemplate
      totalCountCycle
      completedCountCycle
      isCurrent
      createdAt
      updatedAt
      __typename
    }
    companyID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    foreignNationalID
    foreignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    fullname
    firstname
    lastname
    middlename
    archived
    email
    personalEmail
    birthDate
    numberOfDependents
    numberOfFamilyContacts
    displayCompanyName
    companyLegalName
    companyFullName
    sponsoringCompanyFullName
    companyDbaName
    immigrationCurrentStatus
    immigrationStatusExpiration
    birthCountryCode
    citizenshipCountry
    chargeabilityCountry
    passportExpirationDate
    nivMaxout
    visaExpDate
    hasApprovedI140
    petitionerI140
    employmentBasedCategory
    priorityDate
    fnJobTitle
    socCode
    caseSocCode
    fnSalary
    startDate
    fnWorkLocation
    addressPrimary
    addressSecondary
    usResidentialAddress
    lastProcessType
    currentProcessType
    lowerProcessType
    lastPhaseCompleted
    currentPhase
    capType
    eadExpDate
    I797ApprovalExpDate
    I94ExpDate
    I94DS
    greenCardExpDate
    prevailingWageExpDate
    citizenshipEligibilityDate
    rfeDueDate
    dolAuditDueDate
    pwdExpDate
    firstEntryUS
    taxTrackingF1J1
    agreementExpDate
    agreementEffectiveDate
    mswsowExpDate
    permDueDate
    lotterySelectionDueDate
    advancedParoleExpDate
    reEntryPermitExpDate
    certifiedLcaExpDate
    title
    notes
    DS2019ExpDate
    isRelative
    relativeIds
    nextPhase
    requestedProcessSubCategory
    fnNameSlug
    caseSlug
    companyNameSlug
    employerNameSlug
    inviteStatus
    passportNumber
    phoneNumber
    personalPhone
    faxNumber
    passportGender
    preferredMailingAddress
    onboardingSections
    lastEntryUS
    employeeId
    caseNumber
    requestedProcess
    attorneyID
    caseAttorney
    sponsoringEmployerID
    sponsoringNationalID
    caseSponsor
    caseSponsorId
    caseManagerID
    caseManager
    contributorIds
    caseContributors
    caseStartDate
    caseOpenDate
    caseSalary
    state
    workLocation
    keyFilingDates
    lcaFiled
    capGap
    visaAdditionalProcessing
    stemExtEligible
    educationEvaluationNeeded
    wageIssues
    selection
    caseNature
    registrationCompleted
    receiptNumber
    currentCaseStatusText
    modifiedDate
    incompleteUscisReceiptNumber
    caseStatusHistory
    companyAttorneys
    companyAttorneyIds
    companyParalegals
    companyParalegalIds
    companyTotalCases
    companyTotalOpenCases
    companyTotalClosedCases
    companyTotalCompletedCases
    companyNationalCount
    fullTimeEmployeesInUS
    partTimeEmployeesInUS
    companyActiveNationalCount
    grossRevenueForMostRecentFiscalYear
    netRevenueForMostRecentFiscalYear
    naicsCodeOfCompany
    typeOfBusiness
    fein
    yearCompanyWasFoundedInUS
    aosFilingEligible
    requiresMeetingReminder
    isParent
    isPartnerCompany
    companyWhitelistedDomains
    companyContactLabel
    annualMeetingDate
    emCompanyNames
    emCompanyNameSlugs
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateReportEntriesMutationVariables,
  APITypes.UpdateReportEntriesMutation
>;
export const deleteReportEntries = /* GraphQL */ `mutation DeleteReportEntries(
  $input: DeleteReportEntriesInput!
  $condition: ModelReportEntriesConditionInput
) {
  deleteReportEntries(input: $input, condition: $condition) {
    id
    reportID
    report {
      id
      templateID
      companyIds
      accessibleIds
      editableIds
      viewAccess
      editAccess
      type
      name
      status
      numberOfFilters
      numberOfColumns
      fromTemplate
      totalCountCycle
      completedCountCycle
      isCurrent
      createdAt
      updatedAt
      __typename
    }
    companyID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    foreignNationalID
    foreignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    fullname
    firstname
    lastname
    middlename
    archived
    email
    personalEmail
    birthDate
    numberOfDependents
    numberOfFamilyContacts
    displayCompanyName
    companyLegalName
    companyFullName
    sponsoringCompanyFullName
    companyDbaName
    immigrationCurrentStatus
    immigrationStatusExpiration
    birthCountryCode
    citizenshipCountry
    chargeabilityCountry
    passportExpirationDate
    nivMaxout
    visaExpDate
    hasApprovedI140
    petitionerI140
    employmentBasedCategory
    priorityDate
    fnJobTitle
    socCode
    caseSocCode
    fnSalary
    startDate
    fnWorkLocation
    addressPrimary
    addressSecondary
    usResidentialAddress
    lastProcessType
    currentProcessType
    lowerProcessType
    lastPhaseCompleted
    currentPhase
    capType
    eadExpDate
    I797ApprovalExpDate
    I94ExpDate
    I94DS
    greenCardExpDate
    prevailingWageExpDate
    citizenshipEligibilityDate
    rfeDueDate
    dolAuditDueDate
    pwdExpDate
    firstEntryUS
    taxTrackingF1J1
    agreementExpDate
    agreementEffectiveDate
    mswsowExpDate
    permDueDate
    lotterySelectionDueDate
    advancedParoleExpDate
    reEntryPermitExpDate
    certifiedLcaExpDate
    title
    notes
    DS2019ExpDate
    isRelative
    relativeIds
    nextPhase
    requestedProcessSubCategory
    fnNameSlug
    caseSlug
    companyNameSlug
    employerNameSlug
    inviteStatus
    passportNumber
    phoneNumber
    personalPhone
    faxNumber
    passportGender
    preferredMailingAddress
    onboardingSections
    lastEntryUS
    employeeId
    caseNumber
    requestedProcess
    attorneyID
    caseAttorney
    sponsoringEmployerID
    sponsoringNationalID
    caseSponsor
    caseSponsorId
    caseManagerID
    caseManager
    contributorIds
    caseContributors
    caseStartDate
    caseOpenDate
    caseSalary
    state
    workLocation
    keyFilingDates
    lcaFiled
    capGap
    visaAdditionalProcessing
    stemExtEligible
    educationEvaluationNeeded
    wageIssues
    selection
    caseNature
    registrationCompleted
    receiptNumber
    currentCaseStatusText
    modifiedDate
    incompleteUscisReceiptNumber
    caseStatusHistory
    companyAttorneys
    companyAttorneyIds
    companyParalegals
    companyParalegalIds
    companyTotalCases
    companyTotalOpenCases
    companyTotalClosedCases
    companyTotalCompletedCases
    companyNationalCount
    fullTimeEmployeesInUS
    partTimeEmployeesInUS
    companyActiveNationalCount
    grossRevenueForMostRecentFiscalYear
    netRevenueForMostRecentFiscalYear
    naicsCodeOfCompany
    typeOfBusiness
    fein
    yearCompanyWasFoundedInUS
    aosFilingEligible
    requiresMeetingReminder
    isParent
    isPartnerCompany
    companyWhitelistedDomains
    companyContactLabel
    annualMeetingDate
    emCompanyNames
    emCompanyNameSlugs
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteReportEntriesMutationVariables,
  APITypes.DeleteReportEntriesMutation
>;
export const createStandardTemplate = /* GraphQL */ `mutation CreateStandardTemplate(
  $input: CreateStandardTemplateInput!
  $condition: ModelStandardTemplateConditionInput
) {
  createStandardTemplate(input: $input, condition: $condition) {
    id
    fields
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateStandardTemplateMutationVariables,
  APITypes.CreateStandardTemplateMutation
>;
export const updateStandardTemplate = /* GraphQL */ `mutation UpdateStandardTemplate(
  $input: UpdateStandardTemplateInput!
  $condition: ModelStandardTemplateConditionInput
) {
  updateStandardTemplate(input: $input, condition: $condition) {
    id
    fields
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateStandardTemplateMutationVariables,
  APITypes.UpdateStandardTemplateMutation
>;
export const deleteStandardTemplate = /* GraphQL */ `mutation DeleteStandardTemplate(
  $input: DeleteStandardTemplateInput!
  $condition: ModelStandardTemplateConditionInput
) {
  deleteStandardTemplate(input: $input, condition: $condition) {
    id
    fields
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteStandardTemplateMutationVariables,
  APITypes.DeleteStandardTemplateMutation
>;
export const createScheduler = /* GraphQL */ `mutation CreateScheduler(
  $input: CreateSchedulerInput!
  $condition: ModelSchedulerConditionInput
) {
  createScheduler(input: $input, condition: $condition) {
    id
    name
    eventBridgeschedulerName
    eventBridgeSchedulerID
    description
    schedulerExpression
    endDate
    startTime
    frequencyNumber
    frequencyUnit
    startDate
    timeZone
    targetUrl
    entityID
    taskDefinitionID
    taskDefinition {
      id
      taskType
      payload
      recipientIDs
      companyIndividualIDs
      individualIDs
      companyIDs
      updatedAt
      createdAt
      __typename
    }
    updatedAt
    createdAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSchedulerMutationVariables,
  APITypes.CreateSchedulerMutation
>;
export const updateScheduler = /* GraphQL */ `mutation UpdateScheduler(
  $input: UpdateSchedulerInput!
  $condition: ModelSchedulerConditionInput
) {
  updateScheduler(input: $input, condition: $condition) {
    id
    name
    eventBridgeschedulerName
    eventBridgeSchedulerID
    description
    schedulerExpression
    endDate
    startTime
    frequencyNumber
    frequencyUnit
    startDate
    timeZone
    targetUrl
    entityID
    taskDefinitionID
    taskDefinition {
      id
      taskType
      payload
      recipientIDs
      companyIndividualIDs
      individualIDs
      companyIDs
      updatedAt
      createdAt
      __typename
    }
    updatedAt
    createdAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSchedulerMutationVariables,
  APITypes.UpdateSchedulerMutation
>;
export const deleteScheduler = /* GraphQL */ `mutation DeleteScheduler(
  $input: DeleteSchedulerInput!
  $condition: ModelSchedulerConditionInput
) {
  deleteScheduler(input: $input, condition: $condition) {
    id
    name
    eventBridgeschedulerName
    eventBridgeSchedulerID
    description
    schedulerExpression
    endDate
    startTime
    frequencyNumber
    frequencyUnit
    startDate
    timeZone
    targetUrl
    entityID
    taskDefinitionID
    taskDefinition {
      id
      taskType
      payload
      recipientIDs
      companyIndividualIDs
      individualIDs
      companyIDs
      updatedAt
      createdAt
      __typename
    }
    updatedAt
    createdAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSchedulerMutationVariables,
  APITypes.DeleteSchedulerMutation
>;
export const createVendor = /* GraphQL */ `mutation CreateVendor(
  $input: CreateVendorInput!
  $condition: ModelVendorConditionInput
) {
  createVendor(input: $input, condition: $condition) {
    id
    name
    type
    location
    email
    lowerName
    processRequests {
      nextToken
      __typename
    }
    updatedAt
    createdAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateVendorMutationVariables,
  APITypes.CreateVendorMutation
>;
export const updateVendor = /* GraphQL */ `mutation UpdateVendor(
  $input: UpdateVendorInput!
  $condition: ModelVendorConditionInput
) {
  updateVendor(input: $input, condition: $condition) {
    id
    name
    type
    location
    email
    lowerName
    processRequests {
      nextToken
      __typename
    }
    updatedAt
    createdAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateVendorMutationVariables,
  APITypes.UpdateVendorMutation
>;
export const deleteVendor = /* GraphQL */ `mutation DeleteVendor(
  $input: DeleteVendorInput!
  $condition: ModelVendorConditionInput
) {
  deleteVendor(input: $input, condition: $condition) {
    id
    name
    type
    location
    email
    lowerName
    processRequests {
      nextToken
      __typename
    }
    updatedAt
    createdAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteVendorMutationVariables,
  APITypes.DeleteVendorMutation
>;
export const createTaskDefinition = /* GraphQL */ `mutation CreateTaskDefinition(
  $input: CreateTaskDefinitionInput!
  $condition: ModelTaskDefinitionConditionInput
) {
  createTaskDefinition(input: $input, condition: $condition) {
    id
    taskType
    scheduler {
      id
      name
      eventBridgeschedulerName
      eventBridgeSchedulerID
      description
      schedulerExpression
      endDate
      startTime
      frequencyNumber
      frequencyUnit
      startDate
      timeZone
      targetUrl
      entityID
      taskDefinitionID
      updatedAt
      createdAt
      __typename
    }
    payload
    recipientIDs
    companyIndividualIDs
    individualIDs
    companyIDs
    updatedAt
    createdAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTaskDefinitionMutationVariables,
  APITypes.CreateTaskDefinitionMutation
>;
export const updateTaskDefinition = /* GraphQL */ `mutation UpdateTaskDefinition(
  $input: UpdateTaskDefinitionInput!
  $condition: ModelTaskDefinitionConditionInput
) {
  updateTaskDefinition(input: $input, condition: $condition) {
    id
    taskType
    scheduler {
      id
      name
      eventBridgeschedulerName
      eventBridgeSchedulerID
      description
      schedulerExpression
      endDate
      startTime
      frequencyNumber
      frequencyUnit
      startDate
      timeZone
      targetUrl
      entityID
      taskDefinitionID
      updatedAt
      createdAt
      __typename
    }
    payload
    recipientIDs
    companyIndividualIDs
    individualIDs
    companyIDs
    updatedAt
    createdAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTaskDefinitionMutationVariables,
  APITypes.UpdateTaskDefinitionMutation
>;
export const deleteTaskDefinition = /* GraphQL */ `mutation DeleteTaskDefinition(
  $input: DeleteTaskDefinitionInput!
  $condition: ModelTaskDefinitionConditionInput
) {
  deleteTaskDefinition(input: $input, condition: $condition) {
    id
    taskType
    scheduler {
      id
      name
      eventBridgeschedulerName
      eventBridgeSchedulerID
      description
      schedulerExpression
      endDate
      startTime
      frequencyNumber
      frequencyUnit
      startDate
      timeZone
      targetUrl
      entityID
      taskDefinitionID
      updatedAt
      createdAt
      __typename
    }
    payload
    recipientIDs
    companyIndividualIDs
    individualIDs
    companyIDs
    updatedAt
    createdAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTaskDefinitionMutationVariables,
  APITypes.DeleteTaskDefinitionMutation
>;
